import ReactDOM from "react-dom";
import React, { useRef, useState, useEffect } from "react";
import { createRoot } from "react-dom";
import ReactDOMServer from "react-dom/server";
import { appendScriptToHeadOrBody, getSessionObject, httpMiddleware, getDefaultMsids, checkForDummyIDs, checkForMultipleGutterAds, showErrorToast, checkForFullScreenComponents, showWarningToast, showWarningToastFrConfirmation } from "./Utils";
import "./dynamic-form-builder-traits.css";
import registerHtmlPageZipTrait from './html-page-zip-trait';
import TypographyHTMLCode from "./../pages/Home/TypographyHTMLCode";
import MenuItem from "@mui/material/MenuItem";
import TextField from "@mui/material/TextField";
import FormHelperText from "@mui/material/FormHelperText";
import Select from "@mui/material/Select";
import ToggleButton from "@mui/material/ToggleButton";
import ToggleButtonGroup from "@mui/material/ToggleButtonGroup";
// import {GlobalSettingComp} from "../../components/GlobalSetting/GlobalSettingComp";
// import { savePageLayout } from "../../core/Service/LayoutService";
import GlobalSettingComponent from "./GlobalSettingsComponent";
import MenuManagementComponent from "./MenuManagementComponent"

import { PAGE_BUILDER_ENDPOINTS } from "./constants";
import {
  PARENT_COMPONENTS_DATA_MAPPING,
  colorSetOptionsList,
  defaultFontSizes,
  defaultFontWeight,
  API_URLS
} from "./constants";

import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";
import Checkbox from '@mui/material/Checkbox';
import ListItemText from '@mui/material/ListItemText';
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Autocomplete, Button, FormControlLabel, Radio, RadioGroup, Switch, FormControl, InputLabel, FormLabel, Box, Tabs, Tab } from "@mui/material";
import { toast } from 'react-toastify';
import { persistData, logoutUserSession } from "./Utils";
import { getCss } from "./get-css";
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';
import IconButton from '@mui/material/IconButton';

let tempTextFieldValue = '';

const _optionsApiCache = {};

const fetchOptionsFromApi = async (optionsApi, staticOptions = []) => {
  const { url, labelKey = 'label', valueKey = 'value', dataKey = null, mode = 'replace' } = optionsApi;
  if (_optionsApiCache[url]) {
    const cached = _optionsApiCache[url];
    return mode === 'append' ? [...staticOptions, ...cached] : cached;
  }
  try {
    const modifiedurl = url.replace('{hostid}', getSessionObject('hostId'));
    const res = await fetch(modifiedurl);
    const json = await res.json();
    const items = dataKey ? json[dataKey] : (Array.isArray(json) ? json : []);
    const fetched = [...new Map(
        items.map(item => [
            item[valueKey],
            { label: item[labelKey], value: item[valueKey] }
        ])
    ).values()];
    _optionsApiCache[url] = fetched;
    return mode === 'append' ? [...staticOptions, ...fetched] : fetched;
  } catch (e) {
    console.error('[optionsApi] fetch failed:', e);
    return staticOptions;
  }
};

const useOptionsApi = (optionsApi, staticOptions = []) => {
  const [options, setOptions] = useState(staticOptions);
  useEffect(() => {
    if (!optionsApi?.url) return;
    fetchOptionsFromApi(optionsApi, staticOptions).then(setOptions);
  }, [optionsApi?.url]);
  return options;
};

const TraitAccordion = ({ accordionId, label, children, className = '', stateStore }) => {
  const [expanded, setExpanded] = useState(() => Boolean(stateStore?._accordionExpanded));

  return (
    <Accordion
      className={`dynamic-accordion-field-root ${className}`.trim()}
      expanded={expanded}
      onChange={(event, nextExpanded) => {
        event.stopPropagation();
        if (stateStore) stateStore._accordionExpanded = nextExpanded;
        setExpanded(nextExpanded);
      }}
    >
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        aria-controls={`${accordionId}-content`}
        id={`${accordionId}-summary`}
        onMouseDown={(event) => event.stopPropagation()}
        onClick={(event) => event.stopPropagation()}
      >
        <Typography>{label}</Typography>
      </AccordionSummary>
      <AccordionDetails id={`${accordionId}-content`}>{children}</AccordionDetails>
    </Accordion>
  );
};

export const createCustomTraits = (editor) => {
  registerHtmlPageZipTrait(editor);
  editor.TraitManager.addType("custom-textarea", {
    // Expects as return a simple HTML string or an HTML element
    onUpdate({ elInput, component }) {
      let { options, value } = this.model.attributes;
      if (typeof component.attributes.attributes.headAdScript != "undefined"
        && typeof component.attributes.attributes.bodyAdScript != "undefined"
        && typeof component.attributes.attributes.bodyAdMobileScript != "undefined"
        && (component.changed?.status == "selected" || Object.keys(component.changed).length === 0)
      ) {
        value = { ...component.attributes.attributes.headAdScript };
        this.model.attributes.value = { ...component.attributes.attributes.headAdScript };

        if (elInput.querySelector('#headAdScript')) {
          elInput.querySelector('#headAdScript').innerHTML = component.attributes.attributes?.headAdScript;
        }
        if (elInput.querySelector('#bodyAdScript')) {
          elInput.querySelector('#bodyAdScript').innerHTML = component.attributes.attributes?.bodyAdScript;
        }
        if (elInput.querySelector('#bodyAdMobileScript')) {
          elInput.querySelector('#bodyAdMobileScript').innerHTML = component.attributes.attributes?.bodyAdMobileScript;
        }
      }
    },

    createInput({ trait }) {
      // Here we can decide to use properties from the trait
      // Create a new element container and add some content
      const el = document.createElement("div");
      el.innerHTML = `
          <textarea id="${trait.attributes.id}" name="${trait.attributes.name}" value="${trait.attributes.id}" rows="4" cols="50"/>
        `;
      el.querySelector("#" + trait.attributes.id).innerHTML = '';

      //Let's make our content interactive
      const inputsUrl = el.querySelector("#" + trait.attributes.id);
      inputsUrl.addEventListener("change", (ev) => {
        let value = ev.target.value.trim();
        this.model.setValue(value);
        ev.stopPropagation();
      });

      return el;
    },
  });

  editor.TraitManager.addType("custom-urlarea", {
    onUpdate({ elInput, trait, component }) {
      if (this.model.target.attributes.type === "Dynamic Form") {
        const traitName = trait.attributes.name || trait.attributes.id;
        const targetField = elInput.querySelector("#" + trait.attributes.id);
        if (targetField) {
          targetField.value = component.attributes.attributes[traitName] || "";
        }
        return;
      }

      if (this.model.target.attributes.type && this.model.target.attributes.type === 'Breaking News'
        && !(trait.attributes.id == "headAdScript" || trait.attributes.id == "bodyAdScript" || trait.attributes.id == "headAdScript2" || trait.attributes.id == "bodyAdScript2" ||
          trait.attributes.id == "bodyAdMobileScript" || trait.attributes.id == "bodyAdMobileScript2")) {
        elInput.querySelector("#" + trait.attributes.id).value = component.attributes.mainHeadingHref;
      } else if (this.model.target.attributes.type &&
        (this.model.target.attributes.type === 'Hero Layout'
          || this.model.target.attributes.type === 'Grid View'
          || this.model.target.attributes.type === 'Carousel Card Block'
          || this.model.target.attributes.type === 'List View'
          || this.model.target.attributes.type === 'Similar Stories'
          || this.model.target.attributes.type === 'Breaking News'
          || this.model.target.attributes.type === 'Article Show'
          || this.model.target.attributes.type === 'Article Show Amp'
          || this.model.target.attributes.type === 'Hero Layout2'
          || this.model.target.attributes.type === 'Grid View2'
          || this.model.target.attributes.type === 'PhotoList Two'
          || this.model.target.attributes.type === 'Related News'
          || this.model.target.attributes.type === 'Quick View Two'
          || this.model.target.attributes.type === 'Video Carousel Center'
          || this.model.target.attributes.type === 'Video Carousel'
          || this.model.target.attributes.type === 'RhsHome Two'
          || this.model.target.attributes.type === 'HomeCard List'
          || this.model.target.attributes.type === 'RhsHome Other Two'
          || this.model.target.attributes.type === 'WebStories Two'
          || this.model.target.attributes.type === 'Article Show Two Amp'
          || this.model.target.attributes.type === 'Video Show Two Amp'
          || this.model.target.attributes.type === 'Photo Show Two Amp'
          || this.model.target.attributes.type === 'List View Two'
          || this.model.target.attributes.type === 'List View Alt'
          || this.model.target.attributes.type === 'Article Show Two'
          || this.model.target.attributes.type === 'MediaList Two'
          || this.model.target.attributes.type === 'Slide Show Two'
          || this.model.target.attributes.type === 'WebStoriesList Two'
          || this.model.target.attributes.type === 'Podcast Two'
          || this.model.target.attributes.type === 'Liveblog Show'
          || this.model.target.attributes.type === 'Liveblog Show Two'
          || this.model.target.attributes.type === 'Amp Liveblog Show Two'
          || this.model.target.attributes.type === 'Liveblog Show Three'
          || this.model.target.attributes.type === 'GridView Two'
          || this.model.target.attributes.type === 'List View Three'
          || this.model.target.attributes.type === 'Article Three'
          || this.model.target.attributes.type === 'PhotoList Three'
          || this.model.target.attributes.type === 'Quick View Three'
          || this.model.target.attributes.type === 'RhsHome Three'
          || this.model.target.attributes.type === 'RhsHome Other Three'
          || this.model.target.attributes.type === 'WebStories Three'
          || this.model.target.attributes.type === 'Article Show Three Amp'
          || this.model.target.attributes.type === 'Video Show Three Amp'
          || this.model.target.attributes.type === 'Photo Show Three Amp'
          || this.model.target.attributes.type === 'List View Three'
          || this.model.target.attributes.type === 'Article Show Three'
          || this.model.target.attributes.type === 'MediaList Three'
          || this.model.target.attributes.type === 'Slide Show Three'
          || this.model.target.attributes.type === 'WebStoriesList Three'
          || this.model.target.attributes.type === 'Podcast Three'
          || this.model.target.attributes.type === 'GridView Three'
          || this.model.target.attributes.type === 'Rhs Wight'
        )
        && trait.attributes.id != "viewAllUrl") {
        let value = "";
        if (trait.attributes.id == "headAdScript") {
          value = component.attributes.attributes.headAdScript;
        } else if (trait.attributes.id == "bodyAdScript") {
          value = component.attributes.attributes.bodyAdScript;
        } else {
          value = component.attributes.attributes.bodyAdMobileScript;
        }
        elInput.querySelector("#" + trait.attributes.id).value = value;
      } else {
        elInput.querySelector("#" + trait.attributes.id).value = component.attributes.attributes.viewAllUrl;
      }
    },

    createInput({ trait, component }) {
      const elem = document.createElement("div");
      const traitName = trait.attributes.name || trait.attributes.id;

      if (this.model.target.attributes.type === "Dynamic Form") {
        const fieldValue = traitName === "apiBody"
          ? component.attributes.attributes.apiBody || component.attributes.attributes.apiHeaders || ""
          : component.attributes.attributes[traitName] || "";
        if (traitName === "apiBody" || traitName === "apiHeaders") {
          elem.innerHTML = `<textarea id="${trait.attributes.id}" placeholder="Enter optional body as JSON..." rows="4" cols="50">${fieldValue}</textarea>`;
        } else {
          elem.innerHTML = `<input id="${trait.attributes.id}" type="text" placeholder="Enter value here..." value="${fieldValue}"/>`;
        }
      } else

      if (this.model.target.attributes.type && this.model.target.attributes.type === 'Breaking News'
        && !(trait.attributes.id == "headAdScript"
          || trait.attributes.id == "bodyAdScript"
          || trait.attributes.id == "bodyAdMobileScript"
          || trait.attributes.id == "headAdScript2"
          || trait.attributes.id == "bodyAdScript2"
          || trait.attributes.id == "bodyAdMobileScript2")) {
        elem.innerHTML = `<input id="${trait.attributes.id}" type="text" placeholder="Enter Url here..." value="${component.attributes.mainHeadingHref}"/>`;
      } else if (this.model.target.attributes.type
        && (this.model.target.attributes.type === 'Hero Layout'
          || this.model.target.attributes.type === 'Grid View'
          || this.model.target.attributes.type === 'Carousel Card Block'
          || this.model.target.attributes.type === 'List View'
          || this.model.target.attributes.type === 'Similar Stories'
          || this.model.target.attributes.type === 'Breaking News'
          || this.model.target.attributes.type === 'Article Show'
          || this.model.target.attributes.type === 'Article Show Amp'
          || this.model.target.attributes.type === 'Hero Layout2'
          || this.model.target.attributes.type === 'Grid View2'
          || this.model.target.attributes.type === 'PhotoList Two'
          || this.model.target.attributes.type === 'Related News'
          || this.model.target.attributes.type === 'Quick View Two'
          || this.model.target.attributes.type === 'Video Carousel Center'
          || this.model.target.attributes.type === 'Video Carousel'
          || this.model.target.attributes.type === 'RhsHome Two'
          || this.model.target.attributes.type === 'HomeCard List'
          || this.model.target.attributes.type === 'RhsHome Other Two'
          || this.model.target.attributes.type === 'WebStories Two'
          || this.model.target.attributes.type === 'Article Show Two Amp'
          || this.model.target.attributes.type === 'Video Show Two Amp'
          || this.model.target.attributes.type === 'Photo Show Two Amp'
          || this.model.target.attributes.type === 'List View Two'
          || this.model.target.attributes.type === 'List View Alt'
          || this.model.target.attributes.type === 'Article Show Two'
          || this.model.target.attributes.type === 'MediaList Two'
          || this.model.target.attributes.type === 'Slide Show Two'
          || this.model.target.attributes.type === 'WebStoriesList Two'
          || this.model.target.attributes.type === 'Podcast Two'
          || this.model.target.attributes.type === 'Liveblog Show'
          || this.model.target.attributes.type === 'Liveblog Show Two'
          || this.model.target.attributes.type === 'Amp Liveblog Show Two'
          || this.model.target.attributes.type === 'Liveblog Show Three'
          || this.model.target.attributes.type === 'GridView Two'
          || this.model.target.attributes.type === 'List View Three'
          || this.model.target.attributes.type === 'Article Three'
          || this.model.target.attributes.type === 'PhotoList Three'
          || this.model.target.attributes.type === 'Quick View Three'
          || this.model.target.attributes.type === 'RhsHome Three'
          || this.model.target.attributes.type === 'RhsHome Other Three'
          || this.model.target.attributes.type === 'WebStories Three'
          || this.model.target.attributes.type === 'Article Show Three Amp'
          || this.model.target.attributes.type === 'Video Show Three Amp'
          || this.model.target.attributes.type === 'Photo Show Three Amp'
          || this.model.target.attributes.type === 'List View Three'
          || this.model.target.attributes.type === 'Article Show Three'
          || this.model.target.attributes.type === 'MediaList Three'
          || this.model.target.attributes.type === 'Slide Show Three'
          || this.model.target.attributes.type === 'WebStoriesList Three'
          || this.model.target.attributes.type === 'Podcast Three'
          || this.model.target.attributes.type === 'GridView Three'
          || this.model.target.attributes.type === 'Rhs Wight'
        )
        && trait.attributes.id != "viewAllUrl") {
        let script = "";
        if (trait.attributes.id == "headAdScript") {
          script = component.attributes.attributes.headAdScript
        } else if (trait.attributes.id == "bodyAdScript") {
          script = component.attributes.attributes.bodyAdScript
        } else if (trait.attributes.id == "bodyAdMobileScript") {
          script = component.attributes.attributes.bodyAdMobileScript;
        } else if (trait.attributes.id == "headAdScript2") {
          script = component.attributes.attributes.headAdScript2;
        } else if (trait.attributes.id == "bodyAdScript2") {
          script = component.attributes.attributes.bodyAdScript2;
        } else if (trait.attributes.id == "bodyAdMobileScript2") {
          script = component.attributes.attributes.bodyAdMobileScript2;
        }
        //elem.innerHTML = `<input id="${trait.attributes.id}" type="text" placeholder="Enter Url here..." value="${encodeURIComponent(script)}"/>`;
        elem.innerHTML = `<textarea id="${trait.attributes.id}" placeholder="Enter script here..." value="${encodeURIComponent(script)}" rows="4" cols="50"/>`;
      } else {
        elem.innerHTML = `<input id="${trait.attributes.id}" type="text" placeholder="Enter Url here..." value="${component.attributes.attributes.viewAllUrl}"/>`;
      }

      const inputsUrl = elem.querySelector("#" + trait.attributes.id);
      inputsUrl.addEventListener("change", (ev) => {
        let value = ev.target.value.trim();
        // if (!isValidUrl(value)) {
        //   toast.error("URL is not correct");
        //   this.model.attributes.placeholder = "Enter Url here...";
        //   ev.target.value  = '';
        // } else {
        //   this.model.setValue(value);
        // }
        this.model.setValue(value);
        ev.stopPropagation();
      });
      return elem;
    },
  });

  editor.TraitManager.addType("custom-live-input", {
    onUpdate({ elInput, trait, component }) {
      const traitName = trait.attributes.name || trait.attributes.id;
      const inputId = trait.attributes.id || traitName;
      const targetField = elInput.querySelector("#" + inputId);

      if (!targetField) {
        return;
      }

      const componentAttributes = component.attributes.attributes || {};
      const currentValue = componentAttributes[traitName] ?? this.model.get("value") ?? "";

      if (targetField.value !== currentValue) {
        targetField.value = currentValue;
      }
    },

    createInput({ trait, component }) {
      const elem = document.createElement("div");
      const traitName = trait.attributes.name || trait.attributes.id;
      const inputId = trait.attributes.id || traitName;
      const componentAttributes = component.attributes.attributes || {};
      const fieldValue = componentAttributes[traitName] ?? this.model.get("value") ?? "";
      const inputTag = trait.attributes.inputTag === "textarea" ? "textarea" : "input";
      const jsonOnly = Boolean(trait.attributes.jsonOnly);
      const inputEl = document.createElement(inputTag);

      inputEl.id = inputId;
      inputEl.placeholder = trait.attributes.placeholder || "Enter value here...";

      if (inputTag === "textarea") {
        inputEl.rows = trait.attributes.rows || 4;
        inputEl.cols = trait.attributes.cols || 50;
        inputEl.value = fieldValue;
      } else {
        inputEl.type = trait.attributes.inputType || "text";
        inputEl.value = fieldValue;
      }

      const errorEl = document.createElement("div");
      errorEl.style.display = "none";
      errorEl.style.color = "#e35b66";
      errorEl.style.fontSize = "11px";
      errorEl.style.marginTop = "4px";
      errorEl.textContent = 'Must be a valid JSON object, e.g. {"domain":"ILN"}';

      // empty is allowed — the field is optional
      const isJsonObjectText = (value) => {
        if (!value.trim()) return true;
        try {
          const parsed = JSON.parse(value);
          return Boolean(parsed) && typeof parsed === "object" && !Array.isArray(parsed);
        } catch (err) {
          return false;
        }
      };

      const setJsonValidity = (isValid) => {
        errorEl.style.display = isValid ? "none" : "block";
        inputEl.style.borderColor = isValid ? "" : "#e35b66";
      };

      const syncDraftValue = (value) => {
        this.model.attributes.value = value;

        if (typeof component.addAttributes === "function") {
          component.addAttributes({ [traitName]: value }, { silent: true });
          return;
        }

        component.attributes.attributes = component.attributes.attributes || {};
        component.attributes.attributes[traitName] = value;
      };

      inputEl.addEventListener("input", (ev) => {
        if (jsonOnly) {
          const isValid = isJsonObjectText(ev.target.value);
          setJsonValidity(isValid);
          if (!isValid) {
            ev.stopPropagation();
            return;
          }
        }
        syncDraftValue(ev.target.value);
        ev.stopPropagation();
      });

      inputEl.addEventListener("change", (ev) => {
        let value = ev.target.value.trim();
        if (jsonOnly) {
          const isValid = isJsonObjectText(value);
          setJsonValidity(isValid);
          if (!isValid) {
            ev.stopPropagation();
            return;
          }
        }
        syncDraftValue(value);
        this.model.setValue(value);
        ev.stopPropagation();
      });

      elem.appendChild(inputEl);
      if (jsonOnly) {
        elem.appendChild(errorEl);
      }
      return elem;
    },
  });

  editor.TraitManager.addType("submit-button-group", {
    noLabel: true,

    createInput({ component }) {
      const toText = (value) => (value == null ? "" : String(value));
      const attrs = component.attributes.attributes || {};
      const wrapper = document.createElement("div");
      wrapper.className = "submit-button-group-trait";

      const commitAttribute = (attrName, value) => {
        component.attributes.attributes = component.attributes.attributes || {};
        component.attributes.attributes[attrName] = value;
        component.trigger("change:attributes");

        const Renderer = component.attributes.component;
        if (Renderer && component.view && component.view.el) {
          ReactDOM.render(<Renderer {...component.attributes.attributes} />, component.view.el);
        }
      };

      const isJsonObjectText = (value) => {
        if (!value.trim()) return true;
        try {
          const parsed = JSON.parse(value);
          return Boolean(parsed) && typeof parsed === "object" && !Array.isArray(parsed);
        } catch (err) {
          return false;
        }
      };

      const createCard = (titleText, parent = wrapper) => {
        const card = document.createElement("div");
        card.className = "submit-button-card";
        const title = document.createElement("div");
        title.className = "submit-button-card-title";
        title.textContent = titleText;
        card.appendChild(title);
        parent.appendChild(card);
        return card;
      };

      const addLabel = (parent, text) => {
        const label = document.createElement("label");
        label.className = "dynamic-form-trait-label";
        label.textContent = text;
        parent.appendChild(label);
      };

      const addTextInput = (parent, labelText, attrName, placeholder, hintText) => {
        addLabel(parent, labelText);
        const input = document.createElement("input");
        input.type = "text";
        input.className = "dynamic-form-trait-input";
        input.placeholder = placeholder;
        input.value = toText(attrs[attrName]);
        input.addEventListener("change", (ev) => {
          commitAttribute(attrName, ev.target.value.trim());
          ev.stopPropagation();
        });
        input.addEventListener("input", (ev) => ev.stopPropagation());
        parent.appendChild(input);

        if (hintText) {
          const hint = document.createElement("div");
          hint.style.color = "#7a8693";
          hint.style.fontSize = "11px";
          hint.style.margin = "-6px 0 10px";
          hint.textContent = hintText;
          parent.appendChild(hint);
        }
      };

      const addCheckboxInput = (parent, labelText, attrName, hintText) => {
        const label = document.createElement("label");
        label.className = "dynamic-form-trait-checkbox";

        const input = document.createElement("input");
        input.type = "checkbox";
        input.checked = Boolean(attrs[attrName]);
        input.addEventListener("change", (ev) => {
          commitAttribute(attrName, ev.target.checked);
          ev.stopPropagation();
        });
        input.addEventListener("click", (ev) => ev.stopPropagation());

        const text = document.createElement("span");
        text.textContent = labelText;

        label.appendChild(input);
        label.appendChild(text);
        parent.appendChild(label);

        if (hintText) {
          const hint = document.createElement("div");
          hint.style.color = "#7a8693";
          hint.style.fontSize = "11px";
          hint.style.margin = "-6px 0 10px";
          hint.textContent = hintText;
          parent.appendChild(hint);
        }
      };

      // JSON object only, empty allowed
      const addJsonTextarea = (parent, labelText, attrName, hintText) => {
        addLabel(parent, labelText);
        const textarea = document.createElement("textarea");
        textarea.rows = 4;
        textarea.className = "dynamic-form-trait-textarea";
        textarea.placeholder = 'Enter optional body as JSON, e.g. {"domain":"ILN"}';
        textarea.value = toText(attrs[attrName]);

        const error = document.createElement("div");
        error.style.display = "none";
        error.style.color = "#e35b66";
        error.style.fontSize = "11px";
        error.style.margin = "-6px 0 10px";
        error.textContent = 'Must be a valid JSON object, e.g. {"domain":"ILN"}';

        const setJsonValidity = (isValid) => {
          error.style.display = isValid ? "none" : "block";
          textarea.style.borderColor = isValid ? "" : "#e35b66";
        };

        textarea.addEventListener("input", (ev) => {
          setJsonValidity(isJsonObjectText(ev.target.value));
          ev.stopPropagation();
        });
        textarea.addEventListener("change", (ev) => {
          const value = ev.target.value.trim();
          const isValid = isJsonObjectText(value);
          setJsonValidity(isValid);
          if (isValid) {
            commitAttribute(attrName, value);
          }
          ev.stopPropagation();
        });

        parent.appendChild(textarea);
        parent.appendChild(error);

        if (hintText) {
          const hint = document.createElement("div");
          hint.style.color = "#7a8693";
          hint.style.fontSize = "11px";
          hint.style.margin = "-6px 0 10px";
          hint.textContent = hintText;
          parent.appendChild(hint);
        }
      };

      // Primary submit button
      const submitCard = createCard("Submit Button");
      addTextInput(submitCard, "Button Label", "submitText", "Submit");
      addTextInput(submitCard, "Button API Url", "apiBaseUrl", "Enter API URL here...");
      addJsonTextarea(submitCard, "Optional Body", "apiBody");
      addTextInput(
        submitCard,
        "Success Message",
        "successMessage",
        "e.g. Thanks {{name}}, we'll reach out at {{email}}",
        "Use {{payload name}} to insert a form field value."
      );

      addLabel(submitCard, "Click Action");
      const actionSelect = document.createElement("select");
      actionSelect.className = "dynamic-form-trait-select";
      ["Submit", "OTP Verify"].forEach((actionValue) => {
        const option = document.createElement("option");
        option.value = actionValue;
        option.textContent = actionValue;
        actionSelect.appendChild(option);
      });
      actionSelect.value = toText(attrs.clickAction) || "Submit";
      submitCard.appendChild(actionSelect);

      // OTP config — one outer box holding the OTP field + verify button cards,
      // shown only for the OTP Verify flow
      const otpGroup = document.createElement("div");
      otpGroup.className = "submit-button-otp-group";
      const otpGroupTitle = document.createElement("div");
      otpGroupTitle.className = "submit-button-otp-group-title";
      otpGroupTitle.textContent = "OTP Verify";
      otpGroup.appendChild(otpGroupTitle);
      wrapper.appendChild(otpGroup);

      const otpFieldCard = createCard("OTP Field", otpGroup);
      addTextInput(otpFieldCard, "Field Label", "otpFieldLabel", "OTP");
      addTextInput(otpFieldCard, "Payload Name", "otpFieldPayloadName", "API key for OTP e.g. otp (optional)");

      const otpCard = createCard("OTP Verify Button", otpGroup);
      addTextInput(otpCard, "Button Label", "otpSubmitText", "Verify OTP");
      addCheckboxInput(
        otpCard,
        "Enable Resend OTP",
        "enableResendOtp",
        "Shows a resend option below the OTP field"
      );
      addTextInput(otpCard, "Button API Url", "otpApiBaseUrl", "Enter API URL here...");
      addJsonTextarea(
        otpCard,
        "Optional Body",
        "otpApiBody",
        'Use {{payload name}} to insert a form field value, e.g. {"email":"{{email}}"}'
      );
      addTextInput(
        otpCard,
        "Success Message",
        "otpSuccessMessage",
        "e.g. Thanks {{name}}, you're verified!",
        "Use {{payload name}} to insert a form field value, or the OTP field's own Payload Name."
      );

      const syncOtpCardVisibility = () => {
        otpGroup.style.display = actionSelect.value === "OTP Verify" ? "" : "none";
      };
      syncOtpCardVisibility();

      actionSelect.addEventListener("change", (ev) => {
        commitAttribute("clickAction", ev.target.value);
        syncOtpCardVisibility();
        ev.stopPropagation();
      });

      return wrapper;
    },
  });

  editor.TraitManager.addType("custom-toggle", {
    // Expects as return a simple HTML string or an HTML element

    createInput({ trait }) {
      // Here we can decide to use properties from the trait
      // Create a new element container and add some content
      const el = document.createElement("div");
      const isNotChecked = typeof trait.attributes?.isNotChecked === "function"
        ? trait.attributes.isNotChecked()
        : !trait.get('value');

      el.innerHTML = `
            <label class="switch">
              <input type="checkbox" ${isNotChecked ? "" : "checked"}>
              <span class="slider"></span>
          </label>
        `;

      let component = this.getComponent();
      // console.log('showAdSlotField', trait.attributes)

      if (trait.attributes.showViewURLField && !trait.attributes.isNotChecked()) {
        setTimeout(() => {
          component.addTrait({ type: 'custom-urlarea', label: 'View Url', name: 'viewAllUrl' }, { at: 4 })
        })
      } else if (trait.attributes.showAdSlotField) {
        setTimeout(() => {
            // Find the index of the current trait in the collection
            const currentIndex = trait.collection.models.indexOf(trait);
            component.addTrait({
              type: 'belly-ad-accodian-trait',
              label: 'Device',
              name: 'deviceType',
              changeProp: 1,
              options: [
                { label: 'Desktop', value: 'desktop' },
                { label: 'Mobile', value: 'mobile' }
              ],
            }, { at: currentIndex + 1 })
        })
      } else if (trait.attributes.showAdSlotField2 && !trait.attributes.isNotChecked()) {
        setTimeout(() => {
          if (trait.target.attributes.type === "Article Show") {
            component.addTrait({ type: 'custom-radio-buttons', label: 'Ad Size', name: 'adSize2', }, { at: trait.collection.models.length - 1 })
          }
          component.addTrait({
            type: 'custom-select',
            label: 'Ad network',
            name: 'adNetwork2',
            options: [
              { label: 'Google Ad', value: "google" },
              { label: 'Colombia Ad', value: "can" },
            ]
          }, { at: trait.collection.models.length - 1 })
          component.addTrait({ type: 'custom-urlarea', label: 'Header Script', name: 'headAdScript2', }, { at: trait.collection.models.length - 1 })
          component.addTrait({ type: 'custom-urlarea', label: 'Body Script', name: 'bodyAdScript2', }, { at: trait.collection.models.length - 1 })
          component.addTrait({ type: 'custom-urlarea', label: 'Body Script (Mobile)', name: 'bodyAdMobileScript2' }, { at: trait.collection.models.length - 1 })
        })
      } else if (trait.attributes.name === 'showRelatedStories' && !trait.attributes.isNotChecked()) {
        setTimeout(() => {
          if (!component.getTrait('relatedStoriesLable')) {
            const traitIndex = component.get('traits').findIndex(t => t.get('name') === 'showRelatedStories');
            component.addTrait({
              type: 'text',
              label: 'Related stories lable',
              name: 'relatedStoriesLable',
              value: component.attributes.attributes.relatedStoriesLable || 'More stories on',
              changeProp: 1
            }, { at: traitIndex + 1 });
          }
        });
      }

      //Let's make our content interactive
      const inputsUrl = el.querySelector(".slider");
      if (inputsUrl) {
        inputsUrl.addEventListener("click", (ev) => {
          let value = this.model.get("value");
          this.model.setValue(!value);

          if (trait.attributes.showViewURLField) {
            if (!value) {
              component.addTrait({ type: 'custom-urlarea', label: 'View Url', name: 'viewAllUrl' }, { at: 4 })
            } else {
              component.removeTrait("viewAllUrl")
            }
          } else if (trait.attributes.showAdSlotField) {
            if (!value) {
              if (trait.target.attributes.type === "Article Show" || trait.target.attributes.type === "Article Show Two") {
                //component.addTrait({ type: 'custom-radio-buttons', label: 'Ad Size', name: 'adSize', }, { at: trait.collection.models.length - 1 })
              }
              
              // Clear all ad configurations when Ad Slot is turned on
              component.attributes.attributes.adConfigurations = {
                desktop: [],
                mobile: []
              };
              
              // Clear all ad traits
              const desktopAccordions = component.get('desktopAccordions') || [1];
              const mobileAccordions = component.get('mobileAccordions') || [1];
              
              desktopAccordions.forEach(id => {
                component.unset(`adTraits.headAdScript${id}Desktop`);
                component.unset(`adTraits.bodyAdScript${id}Desktop`);
                component.unset(`adTraits.adNetwork${id}Desktop`);
                component.unset(`adTraits.adSize${id}Desktop`);
                component.unset(`adTraits.adSizeCustomWidth${id}Desktop`);
                component.unset(`adTraits.adSizeCustomHeight${id}Desktop`);
                component.unset(`adTraits.paragraphOffset${id}Desktop`);
                component.unset(`adTraits.characterOffset${id}Desktop`);
              });
              desktopAccordions.forEach(id => {
                component.set(`adTraits.headAdScript${id}Desktop`, '');
                component.set(`adTraits.bodyAdScript${id}Desktop`, '');
              });

              mobileAccordions.forEach(id => {
                component.set(`adTraits.headAdScript${id}Mobile`, '');
                component.set(`adTraits.bodyAdScript${id}Mobile`, '');
              });
              
              mobileAccordions.forEach(id => {
                component.unset(`adTraits.headAdScript${id}Mobile`);
                component.unset(`adTraits.bodyAdScript${id}Mobile`);
                component.unset(`adTraits.adNetwork${id}Mobile`);
                component.unset(`adTraits.adSize${id}Mobile`);
                component.unset(`adTraits.adSizeCustomWidth${id}Mobile`);
                component.unset(`adTraits.adSizeCustomHeight${id}Mobile`);
                component.unset(`adTraits.paragraphOffset${id}Mobile`);
                component.unset(`adTraits.characterOffset${id}Mobile`);
              });
              
              // Reset accordions to default state
              component.set('desktopAccordions', [1]);
              component.set('mobileAccordions', [1]);
              
              // Force component update
              component.trigger('change:attributes');
            } else {
              // Clear headScript and bodyScript when toggled on
              const desktopAccordions = component.get('desktopAccordions') || [1];
              const mobileAccordions = component.get('mobileAccordions') || [1];

              desktopAccordions.forEach(id => {
                component.set(`adTraits.headAdScript${id}Desktop`, '');
                component.set(`adTraits.bodyAdScript${id}Desktop`, '');
              });

              mobileAccordions.forEach(id => {
                component.set(`adTraits.headAdScript${id}Mobile`, '');
                component.set(`adTraits.bodyAdScript${id}Mobile`, '');
              });

              // Force component update to reflect changes
              component.trigger('change:attributes');
            }
          } else if (trait.attributes.showAdSlotField2) {
            if (!value) {
              if (trait.target.attributes.type === "Article Show") {
                component.addTrait({ type: 'custom-radio-buttons', label: 'Ad Size', name: 'adSize2', }, { at: trait.collection.models.length - 1 });
              }
              component.addTrait({
                type: 'custom-select',
                label: 'Ad network',
                name: 'adNetwork2',
                options: [
                  { label: 'Google Ad3', value: "google" },
                  { label: 'Colombia Ad3', value: "can" },
                ]
              }, { at: trait.collection.models.length - 1 })
              component.addTrait({ type: 'custom-urlarea', label: 'Header Script', name: 'headAdScript2' }, { at: trait.collection.models.length - 1 })
              component.addTrait({ type: 'custom-urlarea', label: 'Body Script (Desktop)', name: 'bodyAdScript2' }, { at: trait.collection.models.length - 1 })
              component.addTrait({ type: 'custom-urlarea', label: 'Body Script (Mobile)', name: 'bodyAdMobileScript2' }, { at: trait.collection.models.length - 1 })
            } else {
              //setting value to blank in case of adslot removed
              component.traits.models
                .filter(trait => trait.attributes.name === 'adNetwork2')
                .map(trait => trait.setValue('google'));
              component.traits.models
                .filter(trait => trait.attributes.name === 'headAdScript2' || trait.attributes.name === 'bodyAdScript2' || trait.attributes.name === 'bodyAdMobileScript2' || trait.attributes.name === 'adSize2')
                .map(trait => trait.setValue(''));
              component.removeTrait("adNetwork2");
              component.removeTrait("headAdScript2");
              component.removeTrait("bodyAdScript2");
              component.removeTrait("bodyAdMobileScript2");
              component.removeTrait("adSize2");
            }
          } else if (trait.attributes.name === 'showRelatedStories') {
            if (!value) { // Toggled ON
              if (!component.getTrait('relatedStoriesLable')) {
                const traitIndex = component.get('traits').findIndex(t => t.get('name') === 'showRelatedStories');
                component.addTrait({
                  type: 'text',
                  label: 'Related stories lable',
                  name: 'relatedStoriesLable',
                  value: component.attributes.attributes.relatedStoriesLable || 'More stories on',
                  changeProp: 1
                }, { at: traitIndex + 1 });
              }
            } else { // Toggled OFF
              component.removeTrait('relatedStoriesLable');
            }
          }
          ev.stopPropagation();
        });
      }

      return el;
    },

    // onUpdate(el, data) {
    //   const { name, label, options, value } = this.model.attributes;
    //   let selectedVal = value || "1";
    //   const onChange = (event) => {
    //     const selectedValue = event.target.value;
    //     this.model.setValue(selectedValue);
    //   };

    //   const radio = (
    //     <RadioGroup
    //       row
    //       aria-labelledby="demo-row-radio-buttons-group-label"
    //       name="row-radio-buttons-group"
    //       value={selectedVal}
    //       onChange={onChange}
    //     >
    //       <FormControlLabel value="1" control={<Radio />} label="728 X 90" />
    //       <FormControlLabel value="2" control={<Radio />} label="300 X 250" />
    //     </RadioGroup>
    //   );

    //   let elm = this.model.view.el;
    //   let selectedElm = elm.querySelectorAll(".gjs-field-wrp--custom-radio-buttons");

    //   el.component.setAttributes({ ...el.component.attributes.attributes, adSize: selectedVal });
    //   ReactDOM.render(radio, selectedElm[0]);
    // },

  });
  // Add this new trait type definition earlier in the file where other trait types are defined:


  editor.TraitManager.addType("custom-accordion", {
    // Function to render the UI for the trait
    createInput({ }) {
      return `
        <div>
          <div data-gjs-custom-accordion></div>
        </div>
      `;
    },


    onUpdate({ elInput, component }) {
      const { label, content = [] } = this.model.attributes;
      const accordion = (
        <Accordion>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel-content"
            id="panel-header"
          >
            <Typography>Belly Ad</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <div style={{ width: '100%' }}>
              {content.map((item, index) => {
                if (item && item.name && typeof item.name === 'string') {
                  if (!component.get('traits').some(trait => trait.attributes.name === item.name)) {
                    component.addTrait(item, { at: component.get('traits').length });
                  }
                } else {
                  console.error('Invalid item:', item);
                }
              })}
            </div>
          </AccordionDetails>
        </Accordion>
      );

      let elm = this.model.view.el;
      let selectedElm = elm.querySelectorAll(".gjs-field-wrp--custom-accordion");
      if (selectedElm.length > 0) {
        ReactDOM.render(accordion, selectedElm[0]);
      } else {
        console.error('Accordion element not found.');
      }

    }



  });


  editor.TraitManager.addType("custom-radio-buttons", {
    createInput({ }) {
      return `
          <div>
            <div data-gjs-radio-buttons></div>
          </div>
        `;
    },

    // Function to populate the trait with data
    onUpdate(el, data) {
      const { name, label, options, value } = this.model.attributes;
      let selectedVal = value || "1";
      const onChange = (event) => {
        const selectedValue = event.target.value;
        this.model.setValue(selectedValue);
      };

      const radio = (
        <RadioGroup
          row
          aria-labelledby="demo-row-radio-buttons-group-label"
          name="row-radio-buttons-group"
          value={selectedVal}
          onChange={onChange}
        >
          <FormControlLabel value="1" control={<Radio />} label="728 X 90" />
          <FormControlLabel value="2" control={<Radio />} label="300 X 250" />
        </RadioGroup>
      );

      let elm = this.model.view.el;
      let selectedElm = elm.querySelectorAll(".gjs-field-wrp--custom-radio-buttons");

      el.component.setAttributes({ ...el.component.attributes.attributes, adSize: selectedVal });
      ReactDOM.render(radio, selectedElm[0]);
    },
  });

  editor.TraitManager.addType("custom-select", {
    // Function to render the UI for the trait
    createInput({ }) {
      return `
          <div>
            <div data-gjs-custom-select></div>
          </div>
        `;
    },

    // Function to populate the trait with data
    onUpdate(el, data) {
      let { name, label, options, value } = this.model.attributes;
      // Use the value from the component's attributes if available, otherwise fallback
      let selectedVal = (this.target && this.target.attributes && this.target.attributes[name]) || value || (this.target.attributes.seperator || this.target.attributes.type1);
      const onChange = (event) => {
        const selectedValue = event.target.value;
        this.model.setValue(selectedValue);
      };
      let setValueFlag = false;
      if (el.component.attributes.type !== undefined && (el.component.attributes.type === "Ad Scripts" || el.component.attributes.type === "Ad Scripts Two")) {
        if (el.component.attributes.attributes.compWidth > 300 && el.component.attributes.attributes.compWidth < 400) {
          options = [{ label: '300*100', value: "300*100" },
          { label: '300*250', value: "300*250" }]
          setValueFlag = true;
        } else if (el.component.attributes.attributes.compWidth > 970) {
          options = [{ label: '970*90', value: "970*90" }]
          selectedVal = '970*90'
          setValueFlag = true;
        }
      }

      const select = (
        <Select
          value={selectedVal}
          onChange={onChange}
          size="small"
          sx={{
            '& .MuiSelect-select': {
              maxWidth: '150px', // Adjust as needed
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
              display: 'block',
              paddingRight: '32px', // space for caret
            },
          }}
        >
          {options.map((option, index) => (
            <MenuItem key={index} value={option.value}>
              {option.label}
            </MenuItem>
          ))}
        </Select>
      );

      let elm = this.model.view.el;
      let selectedElm = elm.querySelectorAll(".gjs-field-wrp--custom-select");

      ReactDOM.render(select, selectedElm[0]);

      if (setValueFlag) {
        this.model.setValue(selectedVal);
      }
    },
  });

  editor.TraitManager.addType("custom-multi-select", {
    createInput() {
      return `<div><div data-gjs-custom-multi-select></div></div>`;
    },
    onUpdate(el) {
      let { name, options, value } = this.model.attributes;
      let selectedVal = (this.target?.attributes?.[name]) ?? value ?? "";
      const selectedArr = typeof selectedVal === "string"
        ? selectedVal.split(",").map((s) => s.trim()).filter(Boolean)
        : Array.isArray(selectedVal) ? selectedVal : [];

      const resolvedFn = typeof onChangeFn === "function"
        ? onChangeFn
        : typeof onChangeFn === "string" && typeof window[onChangeFn] === "function"
          ? window[onChangeFn]
          : null;

      const onChange = (event) => {
        const val = event.target.value;
        if (Array.isArray(val)) {
          this.model.setValue(val.length ? val.join(",") : "");
        } else {
          this.model.setValue("");
        }
      };

      const select = (
        <Select
          multiple
          value={selectedArr}
          onChange={onChange}
          size="small"
          displayEmpty
          renderValue={(selected) =>
            !selected || selected.length === 0
              ? ""
              : selected
                  .map((v) => options.find((o) => o.value === v)?.label || v)
                  .filter(Boolean)
                  .join(", ")
          }
          sx={{
            "& .MuiSelect-select": {
              maxWidth: "110px",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
              paddingRight: "32px",
            },
          }}
        >
          {options.map((opt, idx) => (
            <MenuItem key={idx} value={opt.value}>
              <Checkbox checked={selectedArr.indexOf(opt.value) > -1} size="small" />
              <ListItemText primary={opt.label} />
            </MenuItem>
          ))}
        </Select>
      );

      let elm = this.model.view.el;
      let target = elm.querySelectorAll(".gjs-field-wrp--custom-multi-select");
      if (target[0]) ReactDOM.render(select, target[0]);
    },
  });

  /**
   * custom-item-list: Add/remove list items with configurable key-value fields.
   * Options: itemFields: [{key, label}], defaultItem: {k: 'v', k2: 'v2'}
   */
  editor.TraitManager.addType("custom-item-list", {
    createInput() {
      return `<div><div data-gjs-custom-item-list></div></div>`;
    },
    onUpdate({ elInput, component }) {
      const { name, itemFields = [], defaultItem = {}, collapsible = false } = this.model.attributes;
      let items = component.attributes.attributes[name];
      if (!Array.isArray(items)) {
        try {
          items = typeof items === "string" ? JSON.parse(items || "[]") : [];
        } catch {
          items = [];
        }
      }
      // if (items.length === 0) {
      //   const initial = Object.keys(defaultItem).length ? { ...defaultItem } : itemFields.reduce((acc, f) => ({ ...acc, [f.key]: "" }), {});
      //   items = [initial];
      // }

      const updateItems = (newItems) => {
        this.model.setValue(newItems);
        if (component.attributes.attributes) {
          component.attributes.attributes[name] = newItems;
        }
        component.trigger("change:attributes");
        this.model.view.render();
      };

      const ItemListEditor = ({ initialItems }) => {
        const [localItems, setLocalItems] = useState(initialItems);
        const [submitted, setSubmitted] = useState(false);
        useEffect(() => setLocalItems(initialItems), [initialItems]);

        const handleFieldChange = (index, key, val) => {
          const newItems = [...localItems];
          if (!newItems[index]) newItems[index] = {};
          newItems[index] = { ...newItems[index], [key]: val };

          const fieldDef = itemFields.find((f) => f.key === key);
          if (fieldDef?.onChangeFill) {
            const { fn, target } = fieldDef.onChangeFill;
            const handler = typeof fn === "function" ? fn : (typeof window[fn] === "function" ? window[fn] : null);
            if (handler) {
              const result = handler(val);
              if (result != null) newItems[index] = { ...newItems[index], [target]: result };
            }
          }

          setLocalItems(newItems);
        };

        const handleAdd = () => {
          const newItem = Object.keys(defaultItem).length ? { ...defaultItem } : itemFields.reduce((acc, f) => ({ ...acc, [f.key]: (f.key === "url" ? "#" : "") }), {});
          setLocalItems([...localItems, newItem]);
        };

        const handleRemove = (index) => {
          const newItems = localItems.filter((_, i) => i !== index);
          const emptyItem = Object.keys(defaultItem).length ? { ...defaultItem } : itemFields.reduce((acc, f) => ({ ...acc, [f.key]: (f.key === "url" ? "#" : "") }), {});
          setLocalItems(newItems.length ? newItems : []);
        };

        const handleUpdate = () => {
          setSubmitted(true);
          const requiredFields = itemFields.filter((f) => f.required);
          for (const item of localItems) {
            for (const f of requiredFields) {
              if (!item[f.key] || !String(item[f.key]).trim()) {
                return;
              }
            }
          }
          updateItems(localItems);
        };

        return (
          <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
            {localItems.map((item, idx) => {
              const fields = itemFields.map((f) => {
                const isEmpty = !!f.required && !(item && item[f.key]);
                return (
                  <TextField
                    key={f.key}
                    size="small"
                    label={f.label}
                    value={(item && item[f.key]) ?? ""}
                    onChange={(e) => handleFieldChange(idx, f.key, e.target.value)}
                    fullWidth
                    variant="outlined"
                    required={!!f.required}
                    error={submitted && isEmpty}
                    helperText={submitted && isEmpty ? `${f.label} is required` : undefined}
                  />
                );
              });

              // Name the row after its first field so collapsed items stay identifiable.
              const firstKey = itemFields[0] && itemFields[0].key;
              const itemName = firstKey && item && item[firstKey] ? String(item[firstKey]) : "";
              const rowTitle = `Item ${idx + 1}${itemName ? " \u2014 " + itemName : ""}`;

              const removeBtn = (
                <IconButton
                  size="small"
                  onClick={(e) => { e.stopPropagation(); handleRemove(idx); }}
                  aria-label="Remove item"
                >
                  <DeleteIcon fontSize="small" />
                </IconButton>
              );

              if (!collapsible) {
                return (
                  <Box key={idx} sx={{ p: 1, border: "1px solid #e0e0e0", borderRadius: 1, display: "flex", flexDirection: "column", gap: 1 }}>
                    <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                      <Typography variant="caption" color="textSecondary">Item {idx + 1}</Typography>
                      {removeBtn}
                    </Box>
                    {fields}
                  </Box>
                );
              }

              return (
                <Accordion
                  key={idx}
                  disableGutters
                  sx={{ border: "1px solid #e0e0e0", borderRadius: 1, boxShadow: "none", "&:before": { display: "none" } }}
                >
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon fontSize="small" />}
                    sx={{ minHeight: 0, "& .MuiAccordionSummary-content": { my: 0.75, mr: 0.5 } }}
                  >
                    <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", width: "100%" }}>
                      <Typography
                        variant="caption"
                        color="textSecondary"
                        sx={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}
                      >
                        {rowTitle}
                      </Typography>
                      {removeBtn}
                    </Box>
                  </AccordionSummary>
                  <AccordionDetails sx={{ display: "flex", flexDirection: "column", gap: 1, pt: 0 }}>
                    {fields}
                  </AccordionDetails>
                </Accordion>
              );
            })}
            <Box sx={{ display: "flex", gap: 1 }}>
              <Button variant="outlined" size="small" startIcon={<AddIcon />} onClick={handleAdd} fullWidth>
                Add Item
              </Button>
              <Button variant="contained" size="small" onClick={handleUpdate} fullWidth>
                Update
              </Button>
            </Box>
          </Box>
        );
      };

      const listUi = <ItemListEditor initialItems={items} />;

      const elm = this.model.view.el;
      const target = elm.querySelectorAll(".gjs-field-wrp--custom-item-list");
      if (target[0]) ReactDOM.render(listUi, target[0]);
    },
  });

  /**
   * Grouped checkboxes with section headings, e.g.
   *
   *   Display On
   *     Web
   *       [x] Left Sidebar
   *       [x] Hamburger Menu
   *       [ ] Sticky/Floating Menu
   *     Mobile
   *       [x] Hamburger Menu
   *       [x] Sticky/Floating Menu
   *
   * Each checkbox writes straight to its own component attribute, so the
   * component still reads plain booleans (props.webLeftSidebar, ...).
   * Configured with: { title, groups: [{ title, options: [{ name, label }] }] }
   */
  editor.TraitManager.addType("custom-checkbox-group", {
    noLabel: true,
    createInput() {
      return `<div><div data-gjs-custom-checkbox-group></div></div>`;
    },
    onUpdate({ component }) {
      const { title = "", groups = [] } = this.model.attributes;

      const CheckboxGroups = () => {
        const readAll = () => {
          const state = {};
          groups.forEach((g) =>
            (g.options || []).forEach((o) => {
              state[o.name] = Boolean(component.attributes.attributes?.[o.name]);
            })
          );
          return state;
        };
        const [values, setValues] = useState(readAll);

        const onToggle = (name) => (event) => {
          const checked = event.target.checked;
          setValues((prev) => ({ ...prev, [name]: checked }));
          if (component.attributes.attributes) {
            component.attributes.attributes[name] = checked;
          }
          component.trigger("change:attributes");
        };

        return (
          <Box sx={{ display: "flex", flexDirection: "column", width: "100%" }}>
            {title ? (
              <Typography variant="caption" sx={{ fontWeight: 700, mb: 0.5 }}>
                {title}
              </Typography>
            ) : null}
            {groups.map((g, gi) => (
              <Box key={gi} sx={{ display: "flex", flexDirection: "column", mt: gi ? 1 : 0, pl: 0.5 }}>
                {g.title ? (
                  <Typography variant="caption" sx={{ fontWeight: 600, opacity: 0.75 }}>
                    {g.title}
                  </Typography>
                ) : null}
                <Box sx={{ display: "flex", flexDirection: "column", pl: 1 }}>
                  {(g.options || []).map((o) => (
                    /* Same markup and classes as the `custom-toggle` field, so
                       these look identical to every other toggle in the panel. */
                    <Box
                      key={o.name}
                      sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", py: 0.4 }}
                    >
                      <Typography variant="body2">{o.label}</Typography>
                      <label className="switch">
                        <input
                          type="checkbox"
                          checked={!!values[o.name]}
                          onChange={onToggle(o.name)}
                        />
                        <span className="slider"></span>
                      </label>
                    </Box>
                  ))}
                </Box>
              </Box>
            ))}
          </Box>
        );
      };

      const elm = this.model.view.el;
      const target = elm.querySelectorAll(".gjs-field-wrp--custom-checkbox-group");
      if (target[0]) ReactDOM.render(<CheckboxGroups />, target[0]);
    },
  });

  editor.TraitManager.addType("dynamic-form-fields", {
    noLabel: true,
    createInput() {
      return `<div><div data-gjs-dynamic-form-fields></div></div>`;
    },

    
    onUpdate({ component }) {
      const { name, label } = this.model.attributes;
      const defaultSelectOptions = "Option 1\nOption 2\nOption 3";
      const supportedFieldTypes = [
        { label: "Text Input", value: "text" },
        { label: "Email Input", value: "email" },
        { label: "Number Input", value: "tel" },
        { label: "Select", value: "select" },
        { label: "Textarea", value: "textarea" },
      ];

      const toText = (value) => (value == null ? "" : String(value));
      const cloneField = (field) => ({ ...field });
      const slugifyLabel = (label, fallback) => {
        const cleaned = toText(label)
          .toLowerCase()
          .trim()
          .replace(/[^a-z0-9]+/g, "_")
          .replace(/^_+|_+$/g, "");
        return cleaned || fallback;
      };

      const resolveFieldType = (source) => {
        const candidates = [
          toText(source?.fieldType).toLowerCase(),
          toText(source?.inputType).toLowerCase(),
          toText(source?.type).toLowerCase(),
        ].filter(Boolean);

        if (candidates.includes("textarea")) return "textarea";
        if (candidates.includes("select")) return "select";
        if (candidates.includes("email")) return "email";
        if (candidates.includes("tel") || candidates.includes("number")) return "tel";
        return "text";
      };

      const buildField = (fieldType, index) => {
        if (fieldType === "select") {
          return {
            fieldType,
            label: `Select Field ${index + 1}`,
            payloadName: "",
            required: false,
            name: `selectField${index + 1}`,
            id: `select-field-${index + 1}`,
            defaultValue: "",
            optionsText: defaultSelectOptions,
          };
        }

        if (fieldType === "textarea") {
          return {
            fieldType,
            label: `Textarea Field ${index + 1}`,
            payloadName: "",
            placeholder: "Enter your message",
            required: false,
            name: `textareaField${index + 1}`,
            id: `textarea-field-${index + 1}`,
            defaultValue: "",
            rows: "4",
          };
        }

        return {
          fieldType,
          label: `${fieldType.charAt(0).toUpperCase()}${fieldType.slice(1)} Field ${index + 1}`,
          payloadName: "",
          placeholder: fieldType === "tel" ? "Enter a number" : fieldType === "email" ? "Enter your email" : "Enter text",
          required: false,
          name: `${fieldType}Field${index + 1}`,
          id: `${fieldType}-field-${index + 1}`,
          defaultValue: "",
        };
      };

      const normaliseOptionsText = (value) => {
        if (Array.isArray(value)) {
          return value
            .map((item) => {
              if (item && typeof item === "object") {
                return toText(item.label || item.value);
              }
              return toText(item);
            })
            .filter(Boolean)
            .join("\n");
        }
        return toText(value);
      };

      const normaliseField = (field, index) => {
        const source = field && typeof field === "object" ? field : {};
        const fieldType = resolveFieldType(source);
        const baseField = buildField(fieldType, index);

        if (fieldType === "select") {
          return {
            ...baseField,
            label: toText(source.label) || baseField.label,
            payloadName: toText(source.payloadName).trim(),
            required: Boolean(source.required),
            name: toText(source.name) || baseField.name,
            id: toText(source.id) || baseField.id,
            defaultValue: toText(source.defaultValue),
            optionsText: normaliseOptionsText(source.optionsText || source.options) || baseField.optionsText,
          };
        }

        if (fieldType === "textarea") {
          return {
            ...baseField,
            label: toText(source.label) || baseField.label,
            payloadName: toText(source.payloadName).trim(),
            placeholder: toText(source.placeholder) || baseField.placeholder,
            required: Boolean(source.required),
            name: toText(source.name) || baseField.name,
            id: toText(source.id) || baseField.id,
            defaultValue: toText(source.defaultValue),
            rows: toText(source.rows) || baseField.rows,
          };
        }

        return {
          ...baseField,
          label: toText(source.label) || baseField.label,
          payloadName: toText(source.payloadName).trim(),
          placeholder: toText(source.placeholder) || baseField.placeholder,
          required: Boolean(source.required),
          name: toText(source.name) || baseField.name,
          id: toText(source.id) || baseField.id,
          value: toText(source.value || source.defaultValue),
        };
      };

      let fields = component.attributes.attributes[name];
      if (!Array.isArray(fields)) {
        try {
          fields = typeof fields === "string" ? JSON.parse(fields || "[]") : [];
        } catch {
          fields = [];
        }
      }
      fields = Array.isArray(fields) ? fields.map((field, index) => normaliseField(field, index)) : [];

      const commitFields = (nextFields) => {
        const normalisedFields = nextFields
          .slice(0, 10)
          .map((field, index) => normaliseField(field, index));
        this.model.setValue(normalisedFields.map(cloneField));
        this.model.attributes.value = normalisedFields.map(cloneField);
        if (component.attributes.attributes) {
          component.attributes.attributes[name] = normalisedFields.map(cloneField);
        }
        component.trigger("change:attributes");

        const Renderer = component.attributes.component;
        if (Renderer && component.view && component.view.el) {
          ReactDOM.render(<Renderer {...component.attributes.attributes} />, component.view.el);
        }
        
        // Force the Trait Manager to re-render to reflect the latest changes.
        if (editor && editor.TraitManager) {
          editor.TraitManager.render();
        }
      };

      // Debounce function to delay execution
      const debounce = (func, delay) => {
        let timeout;
        return function (...args) {
          const context = this;
          clearTimeout(timeout);
          timeout = setTimeout(() => func.apply(context, args), delay);
        };
      };

      const debouncedCommitFields = debounce(commitFields, 300);

      const DynamicFormTraitEditor = ({ initialFields }) => {
        const [localFields, setLocalFields] = useState(initialFields);
        const fieldsRef = useRef(initialFields);
        const getSafeSelectedIndex = (index, fieldCount = fieldsRef.current.length) => {
          if (fieldCount <= 0) {
            return 0;
          }
          const numericIndex = Number.isFinite(index) ? index : Number(index);
          if (!Number.isFinite(numericIndex)) {
            return 0;
          }
          return Math.min(Math.max(numericIndex, 0), fieldCount - 1);
        };
        const [selectedIndex, setSelectedIndex] = useState(() =>
          getSafeSelectedIndex(component._dfbSelectedIndex, initialFields.length)
        );
        const [isAddMenuOpen, setIsAddMenuOpen] = useState(false);
        // collapse state lives on the GrapesJS model so it survives TraitManager re-renders
        const [isCollapsed, setIsCollapsed] = useState(Boolean(component._dfbFieldsCollapsed));
        const [collapsedCards, setCollapsedCards] = useState(() => ({ ...(component._dfbCollapsedCards || {}) }));
        const addMenuRef = useRef(null);

        const setCollapsed = (collapsed) => {
          component._dfbFieldsCollapsed = collapsed;
          setIsCollapsed(collapsed);
        };

        const getFieldCollapseKey = (field, index) =>
          toText(field?.id).trim() || `${field?.fieldType || "field"}-${index}`;

        const syncCollapsedCards = (fieldsToSync, previousState = collapsedCards) => {
          const persistedState = component._dfbCollapsedCards || previousState || {};
          const nextState = fieldsToSync.reduce((acc, field, index) => {
            const key = getFieldCollapseKey(field, index);
            if (persistedState[key]) {
              acc[key] = true;
            }
            return acc;
          }, {});
          component._dfbCollapsedCards = nextState;
          return nextState;
        };

        const persistCollapsedCards = (updater) => {
          setCollapsedCards((previousState) => {
            const nextState = typeof updater === "function" ? updater(previousState) : updater;
            component._dfbCollapsedCards = nextState;
            return nextState;
          });
        };

        fieldsRef.current = localFields;
        const selectCard = (index) => {
          const nextSelectedIndex = getSafeSelectedIndex(index);
          component._dfbSelectedIndex = nextSelectedIndex;
          setSelectedIndex(nextSelectedIndex);
        };

        useEffect(() => {
          setLocalFields(initialFields);
          setCollapsedCards((previousState) => syncCollapsedCards(initialFields, previousState));
          const nextSelectedIndex = getSafeSelectedIndex(component._dfbSelectedIndex, initialFields.length);
          component._dfbSelectedIndex = nextSelectedIndex;
          setSelectedIndex(nextSelectedIndex);
        }, [initialFields]);
        useEffect(() => {
          const nextSelectedIndex = getSafeSelectedIndex(selectedIndex, localFields.length);
          component._dfbSelectedIndex = nextSelectedIndex;
          if (nextSelectedIndex !== selectedIndex) {
            setSelectedIndex(nextSelectedIndex);
          }
        }, [localFields, selectedIndex]);

        useEffect(() => {
          const handleClickOutside = (event) => {
            if (addMenuRef.current && !addMenuRef.current.contains(event.target)) {
              setIsAddMenuOpen(false);
            }
          };

          document.addEventListener("mousedown", handleClickOutside);
          return () => {
            document.removeEventListener("mousedown", handleClickOutside);
          };
        }, []);


        const updateFields = (nextFields) => {
          setLocalFields(nextFields);
          debouncedCommitFields(nextFields);
        };

        const updateField = (index, patch) => {
          const nextFields = [...localFields];
          nextFields[index] = { ...nextFields[index], ...patch };
          updateFields(nextFields);
        };

        const handleFieldTypeChange = (index, newFieldType) => {
          const nextFields = [...fieldsRef.current];
          const currentField = nextFields[index];
          const typeDefaults = buildField(newFieldType, index);

          nextFields[index] = normaliseField(
            {
              ...typeDefaults,
              label: currentField.label,
              payloadName: currentField.payloadName || "",
              name: currentField.name,
              id: currentField.id,
            },
            index
          );

          commitFields(nextFields);
          setLocalFields(nextFields);
        };

        const addField = (fieldType) => {
          if (localFields.length >= 10) {
            setIsAddMenuOpen(false);
            return;
          }
          const nextIndex = localFields.length;
          const nextField = {
            ...buildField(fieldType, nextIndex),
            id: `${slugifyLabel(fieldType, `field_${nextIndex + 1}`)}-${Date.now()}`,
          };
          const nextFields = [...localFields, nextField];
          selectCard(nextFields.length - 1);
          setIsAddMenuOpen(false);
          setCollapsed(false);
          persistCollapsedCards((previousState) => ({
            ...previousState,
            [getFieldCollapseKey(nextField, nextFields.length - 1)]: false,
          }));
          updateFields(nextFields);
        };

        const removeField = async (index) => {
          const fieldToRemove = localFields[index];
          const fieldLabel = toText(fieldToRemove?.label).trim() || `Field ${index + 1}`;
          const userConfirmed = await showWarningToastFrConfirmation(
            `Are you sure you want to remove trait field "${fieldLabel}"?`,
            true
          );

          if (!userConfirmed) {
            return;
          }

          const removedFieldKey = getFieldCollapseKey(fieldToRemove, index);
          const nextFields = localFields.filter((_, fieldIndex) => fieldIndex !== index);
          persistCollapsedCards((previousState) => {
            const nextState = { ...previousState };
            delete nextState[removedFieldKey];
            return syncCollapsedCards(nextFields, nextState);
          });
          if (nextFields.length === 0) {
            selectCard(0);
          } else if (index === selectedIndex) {
            selectCard(Math.min(index, nextFields.length - 1));
          } else if (index < selectedIndex) {
            selectCard(selectedIndex - 1);
          }
          updateFields(nextFields);
        };

        const updateFieldLabel = (index, value) => {
          const nextFields = [...localFields];
          nextFields[index] = { ...nextFields[index], label: value };
          setLocalFields(nextFields);
        };

        const handleLabelBlur = (index, value) => {
          const currentField = fieldsRef.current[index];
          const fallbackSlug = `${currentField.fieldType || "field"}_${index + 1}`;
          const safeSlug = slugifyLabel(value, fallbackSlug);
          const finalFields = [...fieldsRef.current];
          finalFields[index] = { ...finalFields[index], label: value, name: safeSlug, id: `${safeSlug}-${index + 1}` };
          setLocalFields(finalFields);
          commitFields(finalFields);
        };

        const toggleCardCollapsed = (field, index) => {
          const collapseKey = getFieldCollapseKey(field, index);
          persistCollapsedCards((previousState) => ({
            ...previousState,
            [collapseKey]: !previousState[collapseKey],
          }));
        };

        return (
          <div className="dynamic-form-trait-editor">
            <div className="dynamic-form-trait-header">
              <div>
                <div className="dynamic-form-trait-title">Fields</div>
                <div className="dynamic-form-trait-count">{localFields.length} / 10</div>
              </div>
              <div className="dynamic-form-trait-actions">
                <button
                  type="button"
                  className="dynamic-form-trait-add-button"
                  aria-label={isCollapsed ? "Expand fields" : "Collapse fields"}
                  title={isCollapsed ? "Expand fields" : "Collapse fields"}
                  onClick={() => setCollapsed(!isCollapsed)}
                >
                  {isCollapsed ? "▸" : "▾"}
                </button>
                <div className="dynamic-form-trait-add-wrap" ref={addMenuRef}>
                  <button
                    type="button"
                    className="dynamic-form-trait-add-button" // This is the "+" icon inside the React Component
                    aria-label="Add field"
                    disabled={localFields.length >= 10}
                    onClick={() => setIsAddMenuOpen((open) => !open)}
                  >
                    +
                  </button>
                  <div className={`dynamic-form-trait-menu ${isAddMenuOpen ? "is-open" : ""}`}>
                    {supportedFieldTypes.map((typeOption) => (
                      <button
                        key={typeOption.value}
                        type="button"
                        onClick={() => addField(typeOption.value)}
                      >
                        {typeOption.label}
                      </button>
                    ))}
                  </div>
                </div>
              </div>
            </div>

            {!isCollapsed && localFields.length === 0 ? (
              <div className="dynamic-form-trait-empty">
                Add fields using the + button.
              </div>
            ) : null}

            {isCollapsed && localFields.length > 0 ? (
              <div className="dynamic-form-trait-empty">
                {localFields.length} field{localFields.length === 1 ? "" : "s"} hidden. Use ▸ to expand.
              </div>
            ) : null}

            <div className="dynamic-form-trait-list" style={isCollapsed ? { display: "none" } : undefined}>
              {localFields.map((field, index) => {
                const isSelected = selectedIndex === index;
                const isCardCollapsed = Boolean(collapsedCards[getFieldCollapseKey(field, index)]);
                const collapsedTitle = toText(field.label).trim() || `Field ${index + 1}`;
                return (
                  <div
                    key={field.id || `${field.fieldType}-${index}`}
                    className={`dynamic-form-trait-card ${isSelected ? "is-selected" : ""} ${isCardCollapsed ? "is-collapsed" : ""}`}
                    onMouseDownCapture={() => selectCard(index)}
                    onFocusCapture={() => selectCard(index)}
                    onClick={() => selectCard(index)}
                  >
                    <div className="dynamic-form-trait-card-header">
                      <div className="dynamic-form-trait-card-header-main">
                        <div className="dynamic-form-trait-card-index">
                          {`FIELD ${String(index + 1).padStart(2, "0")}`}
                          {isSelected ? " • selected" : ""}
                        </div>
                        {isCardCollapsed ? (
                          <div className="dynamic-form-trait-card-title">{collapsedTitle}</div>
                        ) : null}
                      </div>
                      <div className="dynamic-form-trait-card-actions">
                        <button
                          type="button"
                          className="dynamic-form-trait-card-toggle"
                          aria-label={isCardCollapsed ? "Expand field card" : "Collapse field card"}
                          title={isCardCollapsed ? "Expand field card" : "Collapse field card"}
                          onClick={(event) => {
                            event.stopPropagation();
                            toggleCardCollapsed(field, index);
                          }}
                        >
                          {isCardCollapsed ? "▸" : "▾"}
                        </button>
                        <button
                          type="button"
                          className="dynamic-form-trait-remove"
                          aria-label="Remove field"
                          onClick={async (event) => {
                            event.stopPropagation();
                            await removeField(index);
                          }}
                        >
                          ×
                        </button>
                      </div>
                    </div>

                    {!isCardCollapsed ? (
                      <div className="dynamic-form-trait-card-body">
                        <label className="dynamic-form-trait-label">Field Label</label>
                        <input
                          className="dynamic-form-trait-input"
                          type="text"
                          value={field.label || ""}
                          onChange={(e) => updateFieldLabel(index, e.target.value)}
                          onBlur={(e) => handleLabelBlur(index, e.target.value)}
                        />

                        <label className="dynamic-form-trait-label">Field Type</label>
                        <div
                          style={{ marginBottom: "10px" }}
                          onClick={(event) => {
                            event.stopPropagation();
                            if (!isSelected) {
                              selectCard(index);
                            }
                          }}
                        >
                          <Select
                            value={field.fieldType}
                            onChange={(event) => handleFieldTypeChange(index, event.target.value)}
                            onOpen={() => {
                              if (!isSelected) {
                                selectCard(index);
                              }
                            }}
                            size="small"
                            fullWidth
                            sx={{
                              backgroundColor: "#fff",
                              "& .MuiSelect-select": {
                                backgroundColor: "#fff",
                                fontSize: "13px",
                              },
                            }}
                            MenuProps={{
                              PaperProps: {
                                sx: {
                                  backgroundColor: "#fff",
                                  "& .MuiMenuItem-root": {
                                    backgroundColor: "#fff",
                                    fontSize: "13px",
                                  },
                                },
                              },
                            }}
                            inputProps={{ "aria-label": "Field Type" }}
                          >
                            {supportedFieldTypes.map((typeOption) => (
                              <MenuItem key={typeOption.value} value={typeOption.value}>
                                {typeOption.label}
                              </MenuItem>
                            ))}
                          </Select>
                        </div>

                        <label className="dynamic-form-trait-label">Payload Name</label>
                        <input
                          className="dynamic-form-trait-input"
                          type="text"
                          placeholder="API key for this field e.g. email (optional)"
                          value={field.payloadName || ""}
                          onChange={(e) => {
                            const nextFields = [...localFields];
                            nextFields[index] = { ...nextFields[index], payloadName: e.target.value };
                            setLocalFields(nextFields);
                          }}
                          onBlur={(e) => updateField(index, { payloadName: e.target.value.trim() })}
                        />

                        <label className="dynamic-form-trait-label">Required</label>
                        <label className="dynamic-form-trait-checkbox">
                          <input
                            type="checkbox"
                            checked={Boolean(field.required)}
                            onChange={(event) => updateField(index, { required: event.target.checked })}
                          />
                          <span>Show required mark for this field</span>
                        </label>
                        
                        {field.fieldType === "select" ? (
                          <>
                            <label className="dynamic-form-trait-label">Options</label>
                            <textarea
                              className="dynamic-form-trait-textarea"
                              rows={3}
                              value={field.optionsText || ""}
                              onChange={(event) => {
                                const nextFields = [...localFields];
                                nextFields[index] = { ...nextFields[index], optionsText: event.target.value };
                                setLocalFields(nextFields);
                              }}
                              onBlur={(event) => updateField(index, { optionsText: event.target.value })}
                            />
                          </>
                        ) : null}
                        
                        {/* {field.fieldType === "textarea" ? (
                          <>
                            <label className="dynamic-form-trait-label">Rows</label>
                            <input
                              className="dynamic-form-trait-input"
                              type="number"
                              min="2"
                              value={field.rows || "4"}
                              onChange={(event) => updateField(index, { rows: event.target.value })}
                            />
                          </>
                        ) : null} */}
                      </div>
                    ) : null}
                  </div>
                );
              })}
            </div>
          </div>
        );
      };

      const elm = this.model.view.el;
      const target = elm.querySelectorAll(".gjs-field-wrp--dynamic-form-fields");
      if (target[0]) {
        ReactDOM.render(<DynamicFormTraitEditor initialFields={fields} />, target[0]);
      }
    },
  });

  editor.TraitManager.addType("data-mapping-trait", {
    noLabel: true,

    // Return a simple HTML string or an HTML element
    createInput({ trait }) {
      const mainContainer = document.createElement("div");
      mainContainer.id = "accordian-testing-123";
      return mainContainer;
    },
    onUpdate({ elInput, component }) {
      let { options, value } = this.model.attributes;
     
       //let updatedValue = {...value};
      if (
        typeof component.attributes.attributes.dataMappingTrait !=
        "undefined" &&
        (component.changed?.status == "selected" ||
          Object.keys(component.changed).length === 0)
      ) {
        //initial value
        value = { ...component.attributes.attributes.dataMappingTrait };
        this.model.attributes.value = { ...component.attributes.attributes.dataMappingTrait };
      }
      let onChange,
        finalValue,
        label,
        id = "";
      const onTextChange = (event) => {
        const valueObj = this.model.attributes.value || [];
        if (valueObj == "") { return false }
        this.model.setValue({
          ...valueObj,
          selectContainer: event.target.value,
        });
      };
      const handleChange = (event) => {
        const valueObj = this.model.attributes.value;
        if (valueObj == "") { return false }
        this.model.setValue({
          ...valueObj,
          //selectContainer: "",
          componentBinder: event.target.value,
        });
        if (event.target.value == "pathquery") {
          const mappings = {
            type: "pathquery",
            requestKey: 'msid',
            value: 'object.attributes.ENDPOINTS.forEach(o => { o.queryParams.msid = msid });',
          };
          component.attributes.attributes.mappings = mappings;
        } else if (event.target.value == "sibling") {
          const mappings = {
            type: "siblings",
            requestKey: value.attributeType,
            value: 'object.attributes.ENDPOINTS.forEach(o => { o.queryParams.msid = ' + value.attributeType + ' });',
          };
          component.attributes.attributes.mappings = mappings;
        } else {
          delete component.attributes.attributes.mappings;
        }
      };
      const onChangeParentComponent = (event) => {
        const valueObj = this.model.attributes.value;
        if (
          typeof event.target.value != "undefined" &&
          event.target.value != null
        ) {
          this.model.setValue({
            ...valueObj,
            selectContainer: "",
            parentComponent: event.target.value,
            attributeType: ""
          });
          component.attributes.attributes.parentComponent = event.target.value.split('|')[0];
        }
      };
      //URL FIELD
      // const onChangeUrlField = (event) => {
      //   const valueObj = this.model.attributes.value;
      //   this.model.setValue({
      //     ...valueObj,
      //     selectContainer: "",
      //     urlfield: event.target.value,
      //   });
      //   if (component.attributes.attributes.mappings.type == "pathquery") {
      //     component.attributes.attributes.mappings.requestKey =
      //       event.target.value;
      //     component.attributes.attributes.mappings.value =
      //       'object.attributes.ENDPOINTS.forEach(o => { o.queryParams.' + event.target.value + ' = ' + event.target.value + ' });';
      //   }
      // };
      //ATTRIBUTE TYPE
      const onChangeAttributeType = (event) => {
        const valueObj = this.model.attributes.value;
        if (typeof event.target.value != "undefined" && event.target.value != null) {
          this.model.setValue({
            ...valueObj,
            selectContainer: "",
            attributeType: event.target.value,
          });
          const mappings = {
            type: "siblings",
            requestKey: event.target.value,
            value: 'object.attributes.ENDPOINTS.forEach(o => { o.queryParams.msid = ' + event.target.value + ' });',
          };
          component.attributes.attributes.mappings = mappings;
          getParentComponentsInView1().forEach((op) => {
            if (op.attributes.type == "List View" ||
              op.attributes.type == "Article Show" ||
              op.attributes.type == "Video Show" ||
              op.attributes.type == "Slide Show" ||
              op.attributes.type == "Author Show" ||
              op.attributes.type == "Liveblog Show" ||
              op.attributes.type == "Quiz Show" ||
              op.attributes.type == "Survey Show" ||
              op.attributes.type == "Author Show Two" ||
              op.attributes.type == "Article Show Two" ||
              op.attributes.type == "List View Two" ||
              op.attributes.type == "List View Alt" ||
              op.attributes.type == "Video Show Two" ||
              op.attributes.type == "Podcast Two" ||
              op.attributes.type == "Slide Show Two" ||
              op.attributes.type == "Liveblog Show Two" ||
              op.attributes.type == "Liveblog Show Three" ||
              op.attributes.type == "Author Show Three" ||
              op.attributes.type == "Article Show Three" ||
              op.attributes.type == "List View Three" ||
              op.attributes.type == "Video Show Three" ||
              op.attributes.type == "Podcast Three" ||
              op.attributes.type == "Slide Show Three" ||
              op.attributes.type == "Quiz Show Four" ||
              op.attributes.type == "Survey Show Four") {
              op.attributes.attributes.exportedKeys = { ...op.attributes.attributes.exportedKeys, [event.target.value]: null }
            }
          });
        }
      };
      let top100Films = [];
      const selectContainerOnChange = (event) => {
        const valueObj = this.model.attributes.value;
        if (event.currentTarget.id.includes('autocomplete-select-container-id')) {
          const msidToAdd = event.currentTarget.children[0].getAttribute('value');
          if (!valueObj.selectContainer.includes(msidToAdd)) {
            if (valueObj.selectContainer === '') {
              this.model.setValue({
                ...valueObj,
                selectContainer: msidToAdd
              });
            }
            else if (valueObj.mappingType === 'cp' || valueObj.mappingType === 'ch') {
              this.model.setValue({
                ...valueObj,
                selectContainer: valueObj.selectContainer + "," + msidToAdd
              });
            }
            tempTextFieldValue = '';
          }
        } else if (event.currentTarget.getAttribute("data-testid") === "CancelIcon") {
          const msidToRemove = event.currentTarget.parentElement.children[0].innerHTML;
          const newValue = removeSpecificText(valueObj.selectContainer, msidToRemove);
          this.model.setValue({
            ...valueObj,
            selectContainer: newValue
          });
        }

        function removeSpecificText(commaSeparatedString, textToRemove) {
          const array = commaSeparatedString.split(",");
          const filteredArray = array.filter(item => item !== textToRemove && item !== "");
          return filteredArray.join(",");
        }

      };
      let pageType = '';
      if (typeof getSessionObject("metaData") != 'undefined') {
        pageType = JSON.parse(getSessionObject("metaData"))?.pageType;
      }

      const selectContainerInnerOnChange = (event) => {
        const valueObj = this.model.attributes.value;

        if (event.target.value.length >= 3) {
          let url = PAGE_BUILDER_ENDPOINTS.DENMARK_SEARCH_NEWSROOM + '?hostId=' + getSessionObject('hostId') + '&searchTerms=' + event.target.value;
          const config = {
            url: url,
            method: 'GET',
            headers: {
              'Content-Type': 'application/json',
            },
          };

          httpMiddleware(config)
            .then((response) => {
              if (response.status === 200) {
                const result = response.data;
                if (result.numFound > 0) {
                  top100Films = [];
                  result.response.forEach((item) => {
                    if (item.status == 2) {
                      item.status = 'Active'
                    } else {
                      item.status = 'In-active'
                    }
                    const obj = {
                      name: item.category,
                      msid: item.msid,
                      path: item.path,
                      status: item.status
                    }
                    top100Films.push(obj);
                  })
                  this.model.setValue({
                    ...valueObj,
                    denmarkSearchedItems: top100Films
                  });
                  this.onUpdate({
                    elInput: elInput,
                    component: component
                  });
                } else {
                  this.model.setValue({
                    ...valueObj,
                    denmarkSearchedItems: []
                  });
                  top100Films = [];
                }
              } else {
                throw new Error('Request failed with status: ' + response.status);
              }
            })
            .catch((error) => {
              console.error("API Error:", error);
              return null;
            });
        } else {
          this.model.setValue({
            ...valueObj,
            denmarkSearchedItems: []
          });
          top100Films = [];
        }
        tempTextFieldValue = event.target.value;
      }

      function validateInput(inputString) {
        const regex = new RegExp('^[0-9,]+$');
        return regex.test(inputString);
      }

      let selectAll = false;
      const handleSelectAll = (event) => {
        const valueObj = this.model.attributes.value;
        if (typeof event.target.checked !== 'undefined') {
          if (event.target.checked) {
            const selectedItems = ["article", "video", "slideshow", "audio", "immersivestory", "quiz", "survey", "liveblog"]
            this.model.setValue({
              ...valueObj,
              storyType: selectedItems,
              isChecked: true
            });
          } else {
            this.model.setValue({
              ...valueObj,
              storyType: [],
              isChecked: false
            });
          }
        } else {
          const checkbox = document.querySelector("#selectAll-checkbox");
          if (checkbox) {
            const changeEvent = new Event('change', { bubbles: true });
            checkbox.dispatchEvent(changeEvent);
          }
          // if (event.target.parentElement.parentElement.querySelector('input[type="checkbox"]').checked) {
          //   const selectedItems = ["article", "video", "slideshow", "audio", "immersivestory", "quiz", "survey", "liveblog"]
          //   this.model.setValue({
          //     ...valueObj,
          //     storyType: selectedItems,
          //     isChecked: true
          //   });
          //   //event.target.parentElement.parentElement.querySelector('input[type="checkbox"]').checked = false;
          // } else {
          //   this.model.setValue({
          //     ...valueObj,
          //     storyType: [],
          //     isChecked: false
          //   });
          //   //event.target.parentElement.parentElement.querySelector('input[type="checkbox"]').checked = true;
          // }
        }

      };

      const textObj1 = (
        <Accordion>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel-data-mapping"
            id="panel-data-mapping"
          >
            <Typography>Data Mapping</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <ToggleButtonGroup
              color="primary"
              value={value.componentBinder}
              exclusive
              onChange={handleChange}
              aria-label="Platform"
              size="small"
              style={{ height: "32px", marginBottom: "20px" }}
            >
              <ToggleButton value="static" style={{ textTransform: "none" }}>Static</ToggleButton>
              {(pageType != 'HomePage' && pageType != 'StaticPage' && pageType != 'ErrorPage') && <ToggleButton value="pathquery" style={{ textTransform: "none" }}>URL Driven</ToggleButton>}
              {(pageType != 'HomePage' && pageType != 'StaticPage' && pageType != 'ErrorPage') && !PARENT_COMPONENTS_DATA_MAPPING.includes(
                component.attributes.type
              ) && <ToggleButton value="sibling" style={{ textTransform: "none" }}>Association</ToggleButton>}
            </ToggleButtonGroup>

            {options.map((option, index) => {
              if (index == 0) {
                onChange = (event, element) => {
                  const valueObj = this.model.attributes.value;
                  this.model.setValue({
                    ...valueObj,
                    mappingType: event.target.value,
                    selectContainer: ''
                  });
                };
                id = "data-mapping-type";
                label = "Mapping Type";
                //remoing the not needed mapping types
                if (value.componentBinder == 'static') {
                  option = option.filter(op => op.value !== 'sh' && op.value !== 'ssh' && op.value !== 'auth-list' && op.value !== 'orian-search');
                } else if (value.componentBinder == 'pathquery') {
                  option = option.filter(op => op.value !== 'cp' && op.value !== 'ch' && op.value !== 'sh' && op.value !== 'ssh' && op.value !== 'orian-search');
                } else if (value.componentBinder == 'sibling') {
                  option = option.filter(op => op.value !== 'cp' && op.value !== 'ch' && op.value !== 'sh' && op.value !== 'ssh' && op.value !== 'knowledge-search');
                }

                finalValue = value.mappingType;
              } 
              // else if (index == 1) {
              //   onChange = (event, element) => {
              //     const valueObj = this.model.attributes.value;
              //     if (typeof event.target.value === 'object' && event.target.value.includes("all")) {
              //       event.target.value = ["article", "video", "slideshow", "audio", "immersivestory", "quiz", "survey", "liveblog"];
              //     }
              //     event.target.value = event.target.value.filter((item) => item !== 'select-all');
              //     this.model.setValue({
              //       ...valueObj,
              //       storyType: event.target.value,
              //     });
              //   };
              //   const valueObj = this.model.attributes.value;
              //   if (this.target.attributes.type === "Web Stories" || this.target.attributes.type === "Web Stories2" || this.target.attributes.type === "WebStoriesList Two" || 
              //     this.target.attributes.type === "WebStoriesList Three" || this.target.attributes.type === "WebStories Two" || this.target.attributes.type === "WebStories Three" || 
              //     this.target.attributes.type === "Home Web Stories") {
              //     option = option.filter(op => op.value !== 'article' && op.value !== 'video' && op.value !== 'slideshow' && op.value !== 'audio' && op.value !== 'immersivestory' && op.value !== 'quiz' && op.value !== 'survey' && op.value !== 'liveblog');
              //     value = { ...value, storyType: ["webstory"] };
              //   } else if (this.target.attributes.type === "Video Reel") {
              //     option = option.filter(op => op.value === 'video' || op.value === 'audio');
              //     if (!value.storyType.includes('video') && !value.storyType.includes('audio')) {
              //       value = { ...value, storyType: ["video"] };
              //     }
              //   } else if (this.target.attributes.type === "Circular Card Carousel") {
              //   } else {
              //     option = option.filter(op => op.value !== 'webstory');
              //   }
              //   id = "data-mapping-story-type";
              //   label = "Story Type";
              //   finalValue = value.storyType.filter((item) => item !== 'select-all');
              // } 
              else if (index === 1) {

                // ------------------ ON CHANGE HANDLER ------------------
                onChange = (event, element) => {

                  const valueObj = this.model.attributes.value;

                  // If "all" selected → replace with complete list
                  if (typeof event.target.value === "object" && event.target.value.includes("all")) {
                    event.target.value = [
                      "article", "video", "slideshow", "audio",
                      "immersivestory", "quiz", "survey", "liveblog"
                    ];
                  }
                  // Remove "select-all"
                  event.target.value = event.target.value.filter(
                    item => item !== "select-all"
                  );
                  // Update model
                  this.model.setValue({
                    ...valueObj,
                    storyType: event.target.value
                  });
                };
                // ------------------ PREP VALUES ------------------
                const valueObj = this.model.attributes.value;
                const type = this.target.attributes.type;
                const selectorOnly = this.target.attributes?.attributes?.selectorOnly;
                // Arrays for cleaner checks
                const webStoryTypes = [
                  "Web Stories", "Web Stories2", "WebStoriesList Two",
                  "Webstories List Four",
                  "WebStoriesList Three", "WebStories Two",
                  "WebStories Three", "Home Web Stories"
                ];    
                const removeList = [
                  "article", "video", "slideshow", "audio",
                  "immersivestory", "quiz", "survey", "liveblog"
                ];
                const keepListVideoReel = ["video", "audio"];
                // ------------------ CONDITIONS ------------------
                if(selectorOnly?.length){
                  option = selectorOnly;
                  value = { ...value, storyType: selectorOnly.map(r => r.value) };
                } else if (webStoryTypes.includes(type)) {
                  // Remove all story types except webstory
                  option = option.filter(op => !removeList.includes(op.value));
                  // Set default
                  value = { ...value, storyType: ["webstory"] };
                } else if (type === "Video Reel") {
                    // VIDEO REEL: keep only video + audio in dropdown
                    option = option.filter(op => keepListVideoReel.includes(op.value));
                    // FIX: Clean initial selected values
                    value.storyType = value.storyType.filter(v => keepListVideoReel.includes(v));
                    // If empty after cleaning, set a default
                    if (value.storyType.length === 0) {
                      value.storyType = ["video"];
                    }
                    // Reassign clean value
                    value = { ...value };
                  } else if (type === "Circular Card Carousel") {
                } else {
                  // Remove webstory for all other types
                  option = option.filter(op => op.value !== "webstory");
                }
                // ------------------ FINAL SETTINGS ------------------
                id = "data-mapping-story-type";
                label = "Story Type";
                finalValue = value.storyType.filter(item => item !== "select-all");
              } else if (index == 2) {
                if (value.mappingType == "p") {
                  option = [{ label: "Rank", value: "rank" }];
                  if (option.filter((op) => op.value == value.sortType).length == 0) {
                    value = { ...value, sortType: option[0].value };
                  }
                } else if (
                  value.mappingType == "ch" ||
                  value.mappingType == "cp" ||
                  value.mappingType == "lh"
                ) {
                  option = [
                    { label: "Published Time", value: "date" },
                    { label: "Updated Time", value: "updatedate" },
                  ];
                  if (
                    option.filter((op) => op.value == value.sortType).length ==
                    0
                  ) {
                    value = { ...value, sortType: option[0].value };
                  }
                } else
                  option = [
                    { label: "Rank", value: "rank" },
                    { label: "Published Time", value: "date" },
                    { label: "Updated Time", value: "updatedate" },
                  ];

                onChange = (event, element) => {
                  const valueObj = this.model.attributes.value;
                  this.model.setValue({
                    ...valueObj,
                    sortType: event.target.value,
                  });
                };
                id = "data-mapping-sort-type";
                label = "Sort By";
                finalValue = value.sortType;
              } else if (index == 3) {
                if (
                  value.mappingType == "h" ||
                  value.mappingType == "ch" ||
                  value.mappingType == "lh"
                )
                  option = [{ label: "Descending", value: "dsc" }];

                onChange = (event, element) => {
                  const valueObj = this.model.attributes.value;
                  this.model.setValue({
                    ...valueObj,
                    sortOrder: event.target.value,
                  });
                };
                id = "data-mapping-sort-order";
                label = "Sort Order";
                finalValue = value.sortOrder;
              }
              const parentVal = value.parentComponent;
              let firstPart;
              if (parentVal && parentVal.includes('|')) {
                // Split the string and get the first part
                firstPart = parentVal.split('|')[0];
              } else {
                // Handle the case where | is not present
                firstPart = parentVal;
              }
              return (
                <>
                  <FormHelperText>{label}</FormHelperText>
                  <Select
                    multiple={index === 1 ? true : undefined}
                    key={index}
                    id={id}
                    value={finalValue}
                    onChange={onChange}
                    size="small"
                    fullWidth
                    style={{ marginBottom: "20px", height: "32px" }}
                    renderValue={index === 1 &&
                      ((selected) => {
                        return selected.length === option.length ? 'All Selected' :
                          (() => {
                            const selectedLabels = selected.map((value) => {
                              const selectedOption = option.find((op) => op.value === value);
                              return selectedOption ? selectedOption.label : value;
                            }).join(', ');
                            return selectedLabels.length > 22 ? selectedLabels.substring(0, 22) + '...' : selectedLabels;
                          })();
                      })
                    }
                  >
                    {/* {index === 1 &&
                      <MenuItem key="select-all" value="select-all" onClick={handleSelectAll}>
                        <Checkbox id="selectAll-checkbox" checked={value.isChecked} onChange={handleSelectAll} />
                        <ListItemText primary="Select All" />
                      </MenuItem>
                      // <label>
                      //   <Checkbox checked={value.isChecked} onClick={handleSelectAll} />
                      //   Select all
                      // </label>
                    } */}
                    {index === 1 && option.map((option, index) => (
                      <MenuItem key={index} value={option.value}>
                        <Checkbox checked={finalValue.indexOf(option.value) > -1} />
                        <ListItemText primary={option.label} />
                      </MenuItem>
                    ))}
                    {index !== 1 && option.map((op, index) => (
                      <MenuItem key={index} value={op.value}>
                        {op.label}
                      </MenuItem>
                    ))}
                  </Select>

                  {value.componentBinder == "static" && index == 0 && value.mappingType !== 'keyword-search' && value.mappingType !== 'knowledge-search' && (
                    <>
                      <FormHelperText>Search Section</FormHelperText>
                      {/* <TextField
                        id="select-container-element"
                        value={value.selectContainer}
                        variant="outlined"
                        fullWidth
                        type="number"
                        onChange={onTextChange}
                        style={{ marginBottom: "20px" }}
                      /> */}
                      <Autocomplete
                        multiple
                        id="autocomplete-select-container-id"
                        options={value.denmarkSearchedItems ? value.denmarkSearchedItems : []}
                        getOptionLabel={(option) => {
                          if (typeof option.msid === 'undefined') {
                            return Array.from(option.split(","))
                          }
                          return (
                            <div value={option.msid}>
                              <div class="autocomplete-name">{option.name}</div>
                              <div class="autocomplete-msid-url">{option.msid} - {option.path}</div>
                              <div class="autocomplete-status">{option.status}</div>
                            </div>
                          );
                        }
                        }
                        value={value.selectContainer != '' && validateInput(value.selectContainer) ? (value.selectContainer.includes(',') ? Array.from(value.selectContainer.split(",")) : [value.selectContainer]) : []}
                        filterSelectedOptions
                        onChange={selectContainerOnChange}
                        renderInput={(params) => {
                          params.inputProps.value = tempTextFieldValue
                          if (params.inputProps.ref.current != null) {
                            if (value.mappingType != 'cp' && value.mappingType != 'ch' && value.selectContainer != '') {
                              params.inputProps.ref.current.style.display = 'none';
                            } else {
                              params.inputProps.ref.current.style.display = 'block';
                            }
                          }

                          return (
                            <TextField
                              {...params}
                              placeholder="Add a container"
                              onChange={selectContainerInnerOnChange}
                            />
                          )
                        }
                        }
                        style={{ marginBottom: "20px" }}
                      />
                    </>
                  )}
                  {value.componentBinder == "static" && index == 0 && (value.mappingType === 'keyword-search' || value.mappingType === 'knowledge-search') && (
                    <>
                      <FormHelperText>Search Keyword</FormHelperText>
                      <TextField
                        id="select-container-element"
                        value={value.selectContainer}
                        variant="outlined"
                        fullWidth
                        onChange={onTextChange}
                        style={{ marginBottom: "20px" }}
                      />
                    </>
                  )}

                  {/* {value.componentBinder == "pathquery" && index == 0 && (
                    <>
                      <FormHelperText>URL field</FormHelperText>
                      <Select
                        value={value.urlfield}
                        onChange={onChangeUrlField}
                        size="small"
                        fullWidth
                        style={{ marginBottom: "20px", height: "32px" }}
                      >
                        <MenuItem value="msid">Section/Author</MenuItem>
                        <MenuItem value="keyword">Keyword/Search Term</MenuItem>
                      </Select>
                    </>
                  )} */}

                  {value.componentBinder == "sibling" && index == 0 && (
                    <>
                      <FormHelperText>Parent Component</FormHelperText>
                      <Select
                        value={
                          value.parentComponent != null ? value.parentComponent : null
                        }
                        onChange={onChangeParentComponent}
                        size="small"
                        fullWidth
                        style={{ marginBottom: "20px", height: "32px" }}
                        disabled={getParentComponentsInView2().length === 0}
                      >
                        {getParentComponentsInView3().map((op, index) => (
                          <MenuItem key={index} value={op.attributes.type + (typeof op.attributes.title != "undefined" ? "|" + op.attributes.title : "")}>
                            {op.attributes.type + (typeof op.attributes.title != "undefined" ? "|" + op.attributes.title : "")}
                          </MenuItem>
                        ))}
                      </Select>
                      <FormHelperText>Attribute Type</FormHelperText>
                      <Select
                        value={value.attributeType}
                        onChange={onChangeAttributeType}
                        size="small"
                        fullWidth
                        style={{ marginBottom: "20px", height: "32px" }}
                        disabled={firstPart === null}
                      >

                        {(firstPart === 'Article Show' || firstPart === 'Video Show' || firstPart === 'Slide Show' || firstPart === 'List View' || firstPart === 'Liveblog Show' || firstPart === 'Quiz Show' || firstPart === 'Survey Show' ||
                        firstPart === 'Article Show Two' || firstPart === 'Video Show Two' || firstPart === 'Slide Show Two' || firstPart === 'List View Two' || firstPart === 'List View Alt' || firstPart === 'Podcast Two' || firstPart === 'Liveblog Show Two' ||
                        firstPart === 'Article Show Three' || firstPart === 'Video Show Three' || firstPart === 'Slide Show Three' || firstPart === 'List View Three' || firstPart === 'Podcast Three' || firstPart === 'Liveblog Show Three' ||
                        firstPart === 'Quiz Show Four' || firstPart === 'Survey Show Four') &&
                          <MenuItem value='pid'>
                            Parent Section
                          </MenuItem>}
                        {(firstPart === 'Article Show' || firstPart === 'Video Show' || firstPart === 'Liveblog Show' || 
                        firstPart === 'Article Show Two' || firstPart === 'Video Show Two' || firstPart === 'Podcast Two' || firstPart === 'Liveblog Show Two' || 
                        firstPart === 'Article Show Three' || firstPart === 'Video Show Three' || firstPart === 'Podcast Three' || firstPart === 'Liveblog Show Three') &&
                          <MenuItem value='sectionid'>
                            Article Id
                          </MenuItem>}
                        {(firstPart === 'Article Show' || firstPart === 'Video Show' || firstPart === 'Slide Show' || firstPart === 'Author Show' || firstPart === 'Quiz Show' || firstPart === 'Survey Show' ||
                        firstPart === 'Author Show Two' || firstPart === 'Article Show Two' || firstPart === 'Video Show Two' || firstPart === 'Slide Show Two' || firstPart === 'Podcast Two' ||
                        firstPart === 'Author Show Three' || firstPart === 'Article Show Three' || firstPart === 'Video Show Three' || firstPart === 'Slide Show Three' || firstPart === 'Podcast Three' ||
                        firstPart === 'Quiz Show Four' || firstPart === 'Survey Show Four') &&
                          <MenuItem value='authorid'>
                            Author's Collection
                          </MenuItem>}
                        {(firstPart === 'Article Show' || firstPart === 'Video Show' || firstPart === 'Slide Show' || firstPart === 'Liveblog Show' || firstPart === 'Quiz Show' || firstPart === 'Survey Show' ||
                        firstPart === 'Article Show Two' || firstPart === 'Video Show Two' || firstPart === 'Slide Show Two' || firstPart === 'Podcast Two' || firstPart === 'Liveblog Show Two' ||
                        firstPart === 'Article Show Three' || firstPart === 'Video Show Three' || firstPart === 'Slide Show Three' || firstPart === 'Podcast Three' || firstPart === 'Liveblog Show Three' ||
                        firstPart === 'Quiz Show Four' || firstPart === 'Survey Show Four') &&
                          <MenuItem value='tags'>
                            Keywords / Tags Collection
                          </MenuItem>}
                      </Select>
                    </>
                  )}
                </>
              );
            })}
          </AccordionDetails>
        </Accordion>
      );

      ReactDOM.render(
        textObj1,
        this.model.view.el.querySelector("#accordian-testing-123")
      );

      let default_msid = null;
      let defaultIds = localStorage.getItem("defaultIds");
      let reqHostId = getSessionObject('hostId');
      let defaultSystemHostId = localStorage.getItem("defaultSystemHostId");
      // let defaultSystemTenentId = localStorage.getItem("defaultSystemTenentId");

      if (typeof value.selectContainer === 'string' && value.selectContainer.trim() === "") {
        default_msid = component.attributes.attributes.ENDPOINTS.find((e) => e.name === "MAIN").queryParams.msid;

        if (value.mappingType == "knowledge-search") {
          let defaultKeywords = localStorage.getItem("defaultKeywords");
          if (defaultKeywords) {
            default_msid = defaultKeywords;
            reqHostId = defaultSystemHostId;
          }
        }
        if (value.mappingType == "keyword-search") {
          let defaultKeywords = localStorage.getItem("defaultKeywords");
          if (defaultKeywords) {
            default_msid = defaultKeywords;
            reqHostId = defaultSystemHostId;
          }
        }
        if (value.mappingType == "h" || value.mappingType == "ch" || value.mappingType == "lh") {
          let defaultListingMsid = localStorage.getItem("defaultListingMsid");
          if (defaultListingMsid) {
            default_msid = defaultListingMsid;
            reqHostId = defaultSystemHostId;
          }
        }
        if (value.mappingType == "p" || value.mappingType == "cp") {
          let defaultPriortyListMsid = localStorage.getItem("defaultPriortyListMsid");
          if (defaultPriortyListMsid) {
            default_msid = defaultPriortyListMsid;
            reqHostId = defaultSystemHostId;
          }
        }
        if (value.mappingType == "auth-list") {
          let defaultAuthorID = localStorage.getItem("defaultAuthorID");
          if (defaultAuthorID) {
            default_msid = defaultAuthorID;
            reqHostId = defaultSystemHostId;
          }
        }
        if (value.mappingType == "orian-search") {
          let defaultArticleMsid = localStorage.getItem("defaultArticleMsid");
          if (defaultArticleMsid) {
            default_msid = defaultArticleMsid;
            reqHostId = defaultSystemHostId;
          }
        }

      } else {
        default_msid = value.selectContainer;
      }

      const ENDPOINTS = component.attributes.attributes.ENDPOINTS.map(
        (item) => {
          if (item.name === "MAIN") {

            // if ((!default_msid || default_msid == 'modi') && value.mappingType == "keyword-search" || value.mappingType == "knowledge-search") {
            //   let defaultKeywords = localStorage.getItem("defaultKeywords");
            //   if (defaultKeywords) {
            //     default_msid = defaultKeywords;
            //     reqHostId = defaultSystemHostId;
            //   }
            // }

            if (default_msid && defaultIds && defaultIds.includes(default_msid)) {
              reqHostId = defaultSystemHostId;
            }

            // Replace the value and add a new property
            return {
              ...component.attributes.attributes.ENDPOINTS.find(
                (e) => e.name === "MAIN"
              ),
              queryParams: {
                ...component.attributes.attributes.ENDPOINTS.find(
                  (e) => e.name === "MAIN"
                ).queryParams,
                apiType: value.mappingType,
                msid: default_msid,
                hostId: reqHostId,
                ct: value.storyType,
                st: value.sortType,
                so: value.sortOrder,
              },
            };
          }
          else if (item.name === "HERO_API") {

            // if ((!default_msid || default_msid == 'modi') && value.mappingType == "keyword-search" || value.mappingType == "knowledge-search") {
            //   let defaultKeywords = localStorage.getItem("defaultKeywords");
            //   if (defaultKeywords) {
            //     default_msid = defaultKeywords;
            //     reqHostId = defaultSystemHostId;
            //   }
            // }

            if (default_msid && defaultIds && defaultIds.includes(default_msid)) {
              reqHostId = defaultSystemHostId;
            }

            // Replace the value and add a new property
            return {
              ...component.attributes.attributes.ENDPOINTS.find(
                (e) => e.name === "HERO_API"
              ),
              queryParams: {
                ...component.attributes.attributes.ENDPOINTS.find(
                  (e) => e.name === "HERO_API"
                ).queryParams,
                apiType: value.mappingType,
                msid: default_msid,
                hostId: reqHostId,
                ct: value.storyType,
                st: value.sortType,
                so: value.sortOrder,
              },
            };
          }
          return item;
        }
      );
      component.addAttributes({ ENDPOINTS });
    },
  });

  editor.TraitManager.addType("dynamic-data-mapping-trait", {
    noLabel: true,

    createInput({ trait }) {
      const traitName = trait.get('name') || 'dynamic';
      const mainContainer = document.createElement("div");
      mainContainer.id = `dynamic-data-mapping-${traitName}`;
      return mainContainer;
    },

    onUpdate({ elInput, component }) {
      let { fields = [], value, name: traitName, label: traitLabel } = this.model.attributes;
      const accordionId = `dynamic-mapping-${traitName}`;
      const containerId = `dynamic-data-mapping-${traitName}`;

      if (
        typeof component.attributes.attributes[traitName] !== "undefined" &&
        (component.changed?.status == "selected" || Object.keys(component.changed).length === 0)
      ) {
        value = { ...component.attributes.attributes[traitName] };
        this.model.attributes.value = { ...component.attributes.attributes[traitName] };
      }

      const persist = (updated) => {
        this.model.setValue(updated);
        component.addAttributes({ [traitName]: updated });
      };

      const makeChangeHandler = (fieldName, isToggle = false) => (event) => {
        const newVal = isToggle ? event.target.checked : event.target.value;
        persist({ ...this.model.attributes.value, [fieldName]: newVal });
      };

      const makeTagsChangeHandler = (fieldName) => (event, newValue) => {
        persist({ ...this.model.attributes.value, [fieldName]: newValue });
      };

      const renderField = (field) => {
        const { fieldtype, fieldlabel, name, options = [] } = field;
        const fieldValue = value[name] ?? field.defaultValue ?? '';

        if (fieldtype === 'select' || fieldtype === 'multiselect') {
          const isMulti = fieldtype === 'multiselect';
          const currentValue = isMulti
            ? (Array.isArray(fieldValue) ? fieldValue : [])
            : fieldValue;
          const DynamicSelectField = () => {
            const resolvedOptions = useOptionsApi(field.optionsApi, options);
            const [selectedValue, setSelectedValue] = useState(currentValue);
            const handleSelectChange = (event) => {
              setSelectedValue(event.target.value);
              makeChangeHandler(name)(event);
            };
            return (
              <div className="dmt-toggle-row">
                <FormHelperText>{fieldlabel}</FormHelperText>
                <Select
                  multiple={isMulti}
                  value={selectedValue}
                  onChange={handleSelectChange}
                  size="small"
                  fullWidth
                  style={{ marginBottom: "20px", height: "32px" }}
                  {...(isMulti
                    ? {
                        renderValue: (selected) =>
                          selected.length === resolvedOptions.length
                            ? 'All Selected'
                            : selected.map(v => resolvedOptions.find(p => p.value === v)?.label || v).join(', '),
                      }
                    : {
                        sx: {
                          '& .MuiSelect-select': {
                            maxWidth: '110px',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            whiteSpace: 'nowrap',
                            display: 'block',
                            paddingRight: '32px',
                          },
                        },
                      }
                  )}
                >
                  {resolvedOptions.map((op, i) => (
                    <MenuItem key={i} value={op.value}>
                      {isMulti && <Checkbox checked={selectedValue.indexOf(op.value) > -1} />}
                      {isMulti ? <ListItemText primary={op.label} /> : op.label}
                    </MenuItem>
                  ))}
                </Select>
              </div>
            );
          };
          return <DynamicSelectField key={name} />;
        }

        if (fieldtype === 'tags') {
          const arrValue = Array.isArray(fieldValue) ? fieldValue : [];
          const handleTagAdd = (e) => {
            if (e.key === 'Enter' && e.target.value.trim()) {
              e.preventDefault();
              const newTag = e.target.value.trim();
              if (!arrValue.includes(newTag)) {
                persist({ ...this.model.attributes.value, [name]: [...arrValue, newTag] });
              }
              e.target.value = '';
            }
          };
          const handleTagRemove = (tag) => {
            persist({ ...this.model.attributes.value, [name]: arrValue.filter(t => t !== tag) });
          };
          return (
            <div key={name} className="dmt-toggle-row">
              <FormHelperText>{fieldlabel}</FormHelperText>
              <div className="dmt-tags-container">
                {arrValue.map((tag, i) => (
                  <span key={i} className="dmt-tag">
                    {tag}
                    <button className="dmt-tag-remove" onClick={() => handleTagRemove(tag)}>×</button>
                  </span>
                ))}
                <input
                  className="dmt-tags-input"
                  type="text"
                  placeholder={arrValue.length === 0 ? `Add ${fieldlabel}, press Enter` : ''}
                  onKeyDown={handleTagAdd}
                />
              </div>
            </div>
          );
        }

        if (fieldtype === 'toggle') {
          return (
            <div key={name} className="dmt-toggle-row">
              <span className="dmt-toggle-label">{fieldlabel}</span>
              <div>
                <label className="switch">
                    <input
                      type="checkbox"
                      defaultChecked={!!fieldValue}
                      onChange={makeChangeHandler(name, true)}
                    />
                    <span className="slider"></span>
                </label>
              </div>
            
            </div>
          );
        }

        return (
          <div key={name} className="dmt-toggle-row">
            <FormHelperText>{fieldlabel}</FormHelperText>
            <TextField
              defaultValue={fieldValue}
              type={fieldtype === 'number' ? 'number' : 'text'}
              variant="outlined"
              fullWidth
              size="small"
              onChange={makeChangeHandler(name)}
              style={{ marginBottom: "20px" }}
            />
          </div>
        );
      };

      const ui = (
        <TraitAccordion accordionId={accordionId} label={traitLabel || traitName} stateStore={this.model}>
            {fields.map(renderField)}
        </TraitAccordion>
      );
      const renderTarget = elInput?.id === containerId
        ? elInput
        : elInput?.querySelector?.(`#${containerId}`) || this.model.view.el.querySelector(`#${containerId}`);
      if (renderTarget) ReactDOM.render(ui, renderTarget);
    },
  });

  // Generic flat-attribute accordion used by component configuration groups.
  // Unlike dynamic-data-mapping-trait, each field is persisted directly on the
  // component so existing runtime prop contracts remain intact.
  editor.TraitManager.addType("dynamic-accordion-field", {
    noLabel: true,

    createInput({ trait }) {
      const traitName = trait.get('name') || 'configuration';
      const container = document.createElement('div');
      container.id = `dynamic-accordion-${traitName}`;
      return container;
    },

    onUpdate({ elInput, component }) {
      const { fields = [], name: traitName, label: traitLabel } = this.model.attributes;
      const containerId = `dynamic-accordion-${traitName}`;
      const attributes = component.attributes.attributes || {};

      const persist = (field, value) => {
        if (field.storageName) {
          component.addAttributes({
            [field.storageName]: {
              ...(component.attributes.attributes[field.storageName] || {}),
              [field.name]: value,
            },
          });
        } else {
          component.addAttributes({ [field.name]: value });
        }
      };

      const refreshComponent = () => {
        component.trigger('change:attributes');
        if (component.view && typeof component.view.render === 'function') {
          component.view.render();
        }
      };

      const renderField = (field) => {
        const { fieldtype, fieldlabel, name, options = [] } = field;
        if (fieldtype === 'heading') {
          return <Typography key={name} className="dynamic-accordion-field-heading">{fieldlabel}</Typography>;
        }
        const storedAttributes = field.storageName ? attributes[field.storageName] || {} : attributes;
        const fieldValue = storedAttributes[name] ?? field.defaultValue ?? '';
        const change = (event) => persist(field, fieldtype === 'toggle' ? event.target.checked : event.target.value);

        if (fieldtype === 'select' || fieldtype === 'multiselect') {
          const isMulti = fieldtype === 'multiselect';
          const currentValue = isMulti
            ? (Array.isArray(fieldValue) ? fieldValue : String(fieldValue || '').split(',').filter(Boolean))
            : fieldValue;
          const DynamicAccordionSelect = () => {
            const resolvedOptions = useOptionsApi(field.optionsApi, options);
            const [selectedValue, setSelectedValue] = useState(currentValue);
            const handleSelectChange = (event) => {
              setSelectedValue(event.target.value);
              change(event);
              refreshComponent();
            };
            return (
              <div className="dmt-toggle-row">
                <FormHelperText>{fieldlabel}</FormHelperText>
                <Select
                  multiple={isMulti}
                  value={selectedValue}
                  onChange={handleSelectChange}
                  size="small"
                  fullWidth
                  style={{ marginBottom: '20px', height: '32px' }}
                  {...(isMulti ? {
                    renderValue: (selected) => selected.map(value => resolvedOptions.find(option => option.value === value)?.label || value).join(', '),
                  } : {})}
                >
                  {resolvedOptions.map((option, index) => (
                    <MenuItem key={`${name}-${index}`} value={option.value}>
                      {isMulti && <Checkbox checked={selectedValue.indexOf(option.value) > -1} />}
                      {isMulti ? <ListItemText primary={option.label} /> : option.label}
                    </MenuItem>
                  ))}
                </Select>
              </div>
            );
          };
          return <DynamicAccordionSelect key={name} />;
        }

        if (fieldtype === 'toggle') {
          return (
            <div key={name} className="dmt-toggle-row">
              <span className="dmt-toggle-label">{fieldlabel}</span>
              <label className="switch">
                <input
                  type="checkbox"
                  defaultChecked={fieldValue === true || String(fieldValue).toLowerCase() === 'true'}
                  onChange={(event) => {
                    change(event);
                    refreshComponent();
                  }}
                />
                <span className="slider"></span>
              </label>
            </div>
          );
        }

        return (
          <div key={name} className="dmt-toggle-row">
            <FormHelperText>{fieldlabel}</FormHelperText>
            <TextField
              defaultValue={fieldValue}
              type={fieldtype === 'number' ? 'number' : 'text'}
              variant="outlined"
              fullWidth
              size="small"
              onChange={change}
              onBlur={refreshComponent}
              style={{ marginBottom: '20px' }}
            />
          </div>
        );
      };

      const accordionId = `dynamic-accordion-${traitName}`;
      const ui = (
        <TraitAccordion accordionId={accordionId} label={traitLabel || traitName} stateStore={this.model}>
          {fields.map(renderField)}
        </TraitAccordion>
      );
      const renderTarget = elInput?.id === containerId
        ? elInput
        : elInput?.querySelector?.(`#${containerId}`) || this.model.view.el.querySelector(`#${containerId}`);
      if (renderTarget) ReactDOM.render(ui, renderTarget);
    },
  });

  editor.TraitManager.addType("belly-ad-accodian-trait", {
    noLabel: true,

    createInput({ trait }) {


      const mainContainer = document.createElement("div");
      mainContainer.id = "accordian-testing-1234";
      mainContainer.className = "accordian-wrapper";

      // if(trait.target.attributes.showAdSlot && trait.target.attributes.showAdSlot == true) {
      //   mainContainer.style.display = "block";
      // } else {
      //   mainContainer.style.display = "none";
      // }

      mainContainer.style.display = "none";
      return mainContainer;
    },

    onUpdate({ elInput, trait, component }) {
      // Check if showAdSlot is enabled
      const accordions = component.get('accordions') || [1];
      const MAX_ACCORDIONS = component.attributes.attributes.maxAdsAccordian;

      console.log("trait ::::", trait);

      let deviceType = '';
      if (!["Article Show Amp", "Article Show Two Amp", "Article Show Three Amp", "Photo Show Two Amp", "Photo Show Three Amp", "Ad Scripts Amp", "Ad Scripts Two Amp", "Ad Scripts Three Amp", "Amp Liveblog Show Two"].includes(component.attributes.attributes.name) && 
        !["Photo Show Two Amp", "Photo Show Three Amp"].includes(component.attributes.attributes.title)) {
        deviceType = component.get('deviceType') || 'desktop';
      }
      else {
        deviceType = 'mobile';
      }
      
      // For Left Gutter Ads and Right Gutter Ads, force desktop only
      if (["Left Gutter Ads", "Right Gutter Ads"].includes(component.attributes.attributes.name)) {
        deviceType = 'desktop';
      }

      // Store trait values in component attributes instead of actual traits
      const getTraitValue = (traitName) => {
        return component.get(`adTraits.${traitName}`) || '';
      };
      // Add these functions to collect ad data
      const collectDesktopAds = () => {
        const desktopAccordions = component.get('desktopAccordions') || [1];
        return desktopAccordions.map(id => ({
          id,
          adSize: getTraitValue(`adSize${id}Desktop`) || '1',
          adSizeCustomWidth: getTraitValue(`adSizeCustomWidth${id}Desktop`) || '',
          adSizeCustomHeight: getTraitValue(`adSizeCustomHeight${id}Desktop`) || '',
          adNetwork: getTraitValue(`adNetwork${id}Desktop`) || 'google',
          paragraphOffset: getTraitValue(`paragraphOffset${id}Desktop`) || '',
          characterOffset: getTraitValue(`characterOffset${id}Desktop`) || '',
          adCodeHeight: getTraitValue(`adCodeHeight${id}Desktop`) || '',
          headScript: getTraitValue(`headAdScript${id}Desktop`) || '',
          bodyScript: getTraitValue(`bodyAdScript${id}Desktop`) || ''
        }));
      };

      const collectMobileAds = () => {
        const mobileAccordions = component.get('mobileAccordions') || [1];
        return mobileAccordions.map(id => ({
          id,
          adSize: getTraitValue(`adSize${id}Mobile`) || '1',
          adSizeCustomWidth: getTraitValue(`adSizeCustomWidth${id}Mobile`) || '',
          adSizeCustomHeight: getTraitValue(`adSizeCustomHeight${id}Mobile`) || '',
          adNetwork: getTraitValue(`adNetwork${id}Mobile`) || 'google',
          paragraphOffset: getTraitValue(`paragraphOffset${id}Mobile`) || '',
          characterOffset: getTraitValue(`characterOffset${id}Mobile`) || '',
          adCodeHeight: getTraitValue(`adCodeHeight${id}Mobile`) || '',
          headScript: getTraitValue(`headAdScript${id}Mobile`) || '',
          bodyScript: getTraitValue(`bodyAdScript${id}Mobile`) || ''
        }));
      };

      // Store the collected data in component attributes
      const updateAdConfigurations = () => {
        const desktopAds = collectDesktopAds();
        const mobileAds = collectMobileAds();
        // Only for Gutter Ads, omit the mobile key
        if (
          component.attributes?.attributes?.name === "Left Gutter Ads" ||
          component.attributes?.attributes?.name === "Right Gutter Ads"
        ) {
          component.attributes.attributes.adConfigurations = {
            desktop: desktopAds
          };
        } else {
          component.attributes.attributes.adConfigurations = {
            desktop: desktopAds,
            mobile: mobileAds,
            enableCharCount: component.attributes.attributes.enableCharCount || false
          };
        }
      };

      // Call this whenever ad configurations change
      const handleAdConfigChange = () => {
        updateAdConfigurations();
        // Force component update
        component.trigger('change:attributes');
      };

      // Modify setTraitValue to trigger update
      const setTraitValue = (traitName, value) => {
        component.set(`adTraits.${traitName}`, value);
        // Only trigger full re-render for select/radio changes, not for text fields
        if (traitName.includes('adNetwork') || traitName.includes('adSize')) {
          // Force immediate re-render of the trait manager
          editor.TraitManager.render();
          // Also trigger component refresh
          component.trigger('change:attributes');
        }
        handleAdConfigChange();

        return value;
      };

      // const reOrder = (component, deviceType) => {
      //   const deviceSuffix = deviceType === 'desktop' ? 'Desktop' : 'Mobile';
      //   const accordionKey = deviceType === 'desktop' ? 'desktopAccordions' : 'mobileAccordions';
      //   const addParams = [
      //     'adSize',
      //     'adNetwork',
      //     'paragraphOffset',
      //     'headAdScript',
      //     'bodyAdScript'
      //   ];
      
      //   const accordions = component.get(accordionKey) || [];
      //   const newAccordions = [];
      
      //   accordions.forEach((accId, index) => {
      //     addParams.forEach((addparam) => {
      //       const value = getTraitValue(`${addparam}${accId}${deviceSuffix}`);
      //       component.unset(`adTraits.${addparam}${accId}${deviceSuffix}`);
      //       component.set(`adTraits.${addparam}${index + 1}${deviceSuffix}`, value);
      //       // const newAdTraits = { ...component.get('adTraits') };
      //       // delete newAdTraits[`${addparam}${accId}${deviceSuffix}`];
      //       // newAdTraits[`${addparam}${index + 1}${deviceSuffix}`] = value;
      //       // component.set('adTraits', newAdTraits);
      //     });
      //     newAccordions.push(index + 1); // store new accordion ID
      //   });

      //   // Update the reordered accordions
      //   component.set(accordionKey, newAccordions);

      //   // // After your reordering logic
      //   // component.set('adTraits', { ...component.get('adTraits') });
        
      //   (component.get(accordionKey) || []).forEach((id) => {
      //     console.log("paragraphOffset  :" + id + " ::: " + getTraitValue(`paragraphOffset${id}${deviceSuffix}`));
      //   });

      // };
      

      const deleteAccordion = (id, component, deviceType) => {
        let newAccordions;
      
        if (deviceType === 'desktop') {
          newAccordions = (component.get('desktopAccordions') || []).filter(accId => accId !== id);
          component.set('desktopAccordions', newAccordions);
        } else {
          newAccordions = (component.get('mobileAccordions') || []).filter(accId => accId !== id);
          component.set('mobileAccordions', newAccordions);
        }
      
        // Clear stored trait values
        const deviceSuffix = deviceType === 'desktop' ? 'Desktop' : 'Mobile';
        const traitNames = [
          `adSize${id}${deviceSuffix}`,
          `adSizeCustom${id}${deviceSuffix}`,
          `adNetwork${id}${deviceSuffix}`,
          `paragraphOffset${id}${deviceSuffix}`,
          `characterOffset${id}${deviceSuffix}`,
          `adCodeHeight${id}${deviceSuffix}`,
          `headAdScript${id}${deviceSuffix}`,
          `bodyAdScript${id}${deviceSuffix}`
        ];
      
        traitNames.forEach(name => {
          component.unset(`adTraits.${name}`);
        });

        // reOrder(component, deviceType);

        // Update configurations after removing the accordion
        handleAdConfigChange();

        // Force re-render of the component
        this.model.view.render();
      };

      if (typeof component.attributes.attributes.enableCharCount === 'undefined') {
        component.attributes.attributes.enableCharCount = false;
      }
      const eligibleNonAmpTypes = ["Article Show", "Article Show Two", "Article Show Three", "Article Show Four"];
      const eligibleAmpNames = ["Article Show Amp", "Article Show Two Amp", "Article Show Three Amp"];
      const isNonAmpEligible = trait && trait.target && trait.target.attributes && eligibleNonAmpTypes.includes(trait.target.attributes.type);
      const isAmpEligible = eligibleAmpNames.includes(component.attributes.attributes.name);
      const isCharCountEligible = !!(isNonAmpEligible || isAmpEligible);
      const isAdPositionComponent = component.attributes?.type === "News Social Feed V2"
        || component.attributes?.attributes?.name === "News Social Feed V2";
      // The offset label, hint and note are written for article bodies ("Paragraph Offset",
      // "...before ad rendering in body"). On a story list the number means "after this many
      // stories", so use V2's story wording and suppress the note there. Only the text changes —
      // input rules stay whole-number (not isAdPositionComponent, which allows decimals).
      // Additive: every other component evaluates this as false and is unaffected.
      const isStoryListAdComponent = component.attributes?.type === "Vertical List Four"
        || component.attributes?.attributes?.name === "Vertical List Four";
      // Mobile Vertical List Four shows two stories per row, and an ad after an odd story leaves a
      // hole in the grid. Keep digits only, round odd up to the next even number, cap at 98 (the
      // box takes two digits). Used on the Mobile tab only; desktop is one story per row.
      const toEvenStoryPosition = (raw) => {
        const digits = String(raw ?? '').replace(/[^0-9]/g, '');
        if (digits === '') return '';
        const n = Number(digits);
        return String(Math.min(n % 2 === 0 ? n : n + 1, 98));
      };
      const EVEN_POSITION_NOTE = "Mobile shows 2 stories per row. Use even numbers (2, 4, 6…)";
      // Tells the author the box just rewrote their value: the box glows amber for 1s and the note
      // says what changed for 3s. Plain DOM, because this panel has no React state of its own.
      // A timer is kept per element so a quick second edit restarts it instead of stacking.
      const flashEvenPositionChange = (inputEl, typed, saved) => {
        // Tint goes on the input root, which sits behind the text; the outline is drawn on top of it.
        const inputRoot = inputEl.closest('.MuiOutlinedInput-root');
        const outline = inputRoot?.querySelector('.MuiOutlinedInput-notchedOutline');
        if (inputRoot && outline) {
          clearTimeout(inputRoot._evenFlashTimer);
          inputRoot.style.transition = 'background-color 0.3s';
          outline.style.transition = 'border-color 0.3s';
          inputRoot.style.backgroundColor = 'rgba(245, 158, 11, 0.12)';
          outline.style.borderColor = '#f59e0b';
          outline.style.borderWidth = '2px';
          inputRoot._evenFlashTimer = setTimeout(() => {
            inputRoot.style.backgroundColor = '';
            outline.style.borderColor = '';
            outline.style.borderWidth = '';
          }, 1000);
        }
        const note = inputEl.closest('.label-adpoffset-textfield')?.querySelector('.even-position-note');
        if (note) {
          clearTimeout(note._evenFlashTimer);
          note.textContent = `⚠ Changed ${typed} to ${saved}. Mobile needs even numbers.`;
          note.style.color = '#b45309';
          note.style.fontWeight = '600';
          note._evenFlashTimer = setTimeout(() => {
            note.textContent = EVEN_POSITION_NOTE;
            note.style.color = '';
            note.style.fontWeight = '';
          }, 3000);
        }
      };
      const enableCharCount = isCharCountEligible && ((typeof component.attributes.attributes.enableCharCount !== 'undefined')
        ? component.attributes.attributes.enableCharCount
        : (component.get('enableCharCount') || false));

      const AdSlottextObj1 = (
        <Box sx={{ padding: '10px', border: '1px solid #e0e0e0', borderRadius: '4px' }}>
        <div id="myadslot">
          {/* Enable Char Count Toggle (UI only) */}
          {isCharCountEligible && (
            <Box sx={{ padding: '10px', border: '1px solid #e0e0e0', borderRadius: '4px' , display: 'flex', justifyContent: 'flex-start', alignItems: 'center', gap: '10px', marginBottom: '8px' }}>
              <Typography style={{ fontSize: '14px', color: '#8a8a8a' }}>Ads by Char Count</Typography>
              <label class="switch">
                <input type="checkbox" checked={enableCharCount} onChange={(e) => { 
                  const checked = e.target.checked; 
                  component.set('enableCharCount', checked); 
                  component.attributes.attributes.enableCharCount = checked; 
                  handleAdConfigChange();
                  component.trigger('change:attributes');
                  this.model.view.render(); 
                }} />
                <span class="slider round"></span>
              </label>
            </Box>
          )}
          {isCharCountEligible && <Box sx={{ flexGrow: 1, display: 'flex', alignItems: 'center' }}>
            <Box sx={{ height: '1px', width: '50%', backgroundColor: '#e0e0e0', margin: '0 auto' }} />
          </Box> }
          {/* Device Type Tabs */}

          <Box sx={{
            borderBottom: 1,
            borderColor: 'divider',
            marginBottom: 2,
            display: 'flex',
            justifyContent: 'center'
          }}>
            <Tabs
              value={deviceType}
              onChange={(e, newValue) => {
                component.set('deviceType', newValue);
              }}
              sx={{
                minHeight: '35px',
                '& .MuiTabs-flexContainer': {
                  justifyContent: 'center'
                }
              }}
              centered
            >
              {!["Article Show Amp", "Article Show Two Amp", "Article Show Three Amp", "Photo Show Two Amp", "Photo Show Three Amp", "Ad Scripts Amp", "Ad Scripts Two Amp", "Ad Scripts Three Amp","Amp Liveblog Show Two"].includes(component.attributes.attributes.name) && 
              !["Photo Show Two Amp", "Photo Show Three Amp"].includes(component.attributes.attributes.title) && (
                <Tab
                  value="desktop"
                  label="Desktop"
                  sx={{
                    textTransform: 'none',
                    minHeight: '35px',
                    padding: '0 10px'
                  }}
                />
              )}
              {!["Left Gutter Ads", "Right Gutter Ads"].includes(component.attributes.attributes.name) && (
                <Tab
                  value="mobile"
                  label="Mobile"
                  sx={{
                    textTransform: 'none',
                    minHeight: '35px',
                    padding: '0 10px'
                  }}
                />
              )}
            </Tabs>
          </Box>

          {/* Desktop View */}
          {deviceType === 'desktop' && ((!["Article Show Amp", "Article Show Two Amp", "Article Show Three Amp", "Photo Show Two Amp", "Photo Show Three Amp", "Ad Scripts Amp", "Ad Scripts Two Amp", "Ad Scripts Three Amp", "Amp Liveblog Show Two"].includes(component.attributes.attributes.name) && 
          !["Photo Show Two Amp", "Photo Show Three Amp"].includes(component.attributes.attributes.title)) || 
          ["Left Gutter Ads", "Right Gutter Ads"].includes(component.attributes.attributes.name)) && (
            <>
              {(component.get('desktopAccordions') || [1]).map((id, index) => (
                <Accordion
                  key={`desktop-${id}`}
                  sx={{
                    marginBottom: '10px',
                    border: '1px solid #e0e0e0',
                    '&.Mui-expanded': {
                      boxShadow: '0 2px 4px rgba(0,0,0,0.05)'
                    }
                  }}
                >
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls={`panel-desktop-${id}`}
                    id={`panel-desktop-${id}`}
                    style={{ position: 'relative' }}
                  >

                    <Typography>
                      {component.attributes.attributes.adSlotLable === "Ad"
                        ? `Ad code`
                        : `Belly Ad code ${index+1}`}
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <div style={{ width: '100%' }}>
                      {/* Desktop Ad Network */}
                      <FormControl fullWidth style={{ marginBottom: '10px' }}>
                        <Select
                          value={getTraitValue(`adNetwork${id}Desktop`) || 'google'}
                          onChange={(e) => {
                            setTraitValue(`adNetwork${id}Desktop`, e.target.value); // Changed Desktop to Mobile
                            // Force component update
                            component.set(`adTraits.adNetwork${id}Desktop`, e.target.value); // Changed Desktop to Mobile
                            // Trigger a re-render
                            this.model.view.render();
                          }}
                          size="small"
                          style={{
                            display: component.attributes.attributes.dataMappingTrait &&
                              component.attributes.attributes.dataMappingTrait.mappingType !== 'cp' &&
                              component.attributes.attributes.dataMappingTrait.mappingType !== 'ch' &&
                              component.attributes.attributes.dataMappingTrait.selectContainer !== ''
                              ? 'none'
                              : 'block'
                          }}
                        >
                          <MenuItem value="google">Google Ad</MenuItem>
                          <MenuItem value="can">Others</MenuItem>
                        </Select>
                      </FormControl>

                      {/* Desktop Ad Size Radio Group */}
                      {(["Ad Scripts", "Ad Scripts Two", "Ad Scripts Three", "Ad Scripts Amp", "Ad Scripts Two Amp", "Ad Scripts Three Amp"].includes(component.attributes.attributes.name) &&
                        <FormControl fullWidth style={{ marginBottom: '10px' }}>
                          <FormLabel style={{ fontSize: '13px', color: '#8a8a8a' }}>Ad Slot Size</FormLabel>
                          <RadioGroup
                            row
                            defaultValue={getTraitValue(`adSize${id}Desktop`)}
                            onChange={(e) => setTraitValue(`adSize${id}Desktop`, e.target.value)}
                          >
                            <FormControlLabel value="970x90" control={<Radio size="small" />} label="970 X 90" sx={{ '& .MuiFormControlLabel-label': { fontSize: '14px' }, margin: '2px' }} />
                            <FormControlLabel value="300x600" control={<Radio size="small" />} label="300 X 600" sx={{ '& .MuiFormControlLabel-label': { fontSize: '14px' }, margin: '2px' }} />
                            <FormControlLabel value="300x250" control={<Radio size="small" />} label="300 X 250" sx={{ '& .MuiFormControlLabel-label': { fontSize: '14px' }, margin: '2px' }} />
                            <FormControlLabel value="336x280" control={<Radio size="small" />} label="336 X 280" sx={{ '& .MuiFormControlLabel-label': { fontSize: '14px' }, margin: '2px' }} />
                            <FormControlLabel value="others" control={<Radio size="small" />} label="Others" sx={{ '& .MuiFormControlLabel-label': { fontSize: '14px' }, margin: '2px' }} />
                            <FormControlLabel value="stickyOverlayAds" control={<Radio size="small" />} label="Sticky Overlay" sx={{ '& .MuiFormControlLabel-label': { fontSize: '14px' }, margin: '2px' }} />
                          </RadioGroup>
                          {getTraitValue(`adSize${id}Desktop`) === 'others' && (
                            <div style={{ display: 'flex', gap: '10px', marginTop: '10px', marginBottom: '15px' }}>
                              <TextField
                                placeholder="Width"
                                defaultValue={getTraitValue(`adSizeCustomWidth${id}Desktop`) || ''}
                                onBlur={(e) => setTraitValue(`adSizeCustomWidth${id}Desktop`, e.target.value)}
                                size="small"
                                style={{ flex: 1 }}
                              />
                              <TextField
                                placeholder="Height"
                                defaultValue={getTraitValue(`adSizeCustomHeight${id}Desktop`) || ''}
                                onBlur={(e) => setTraitValue(`adSizeCustomHeight${id}Desktop`, e.target.value)}
                                size="small"
                                style={{ flex: 1 }}
                              />
                            </div>
                          )}
                        </FormControl>
                      )}

                      {/* Desktop Scripts */}

                      <div className="adScriptWrapper">
                      {component.attributes.attributes.adSlotLable === "Belly" && (
                          <>
                            {(isAdPositionComponent || isStoryListAdComponent) ? (
                              <p className="label-adtextfield">Insert Position(After Only Story)</p>
                            ) : isCharCountEligible && enableCharCount ? (
                              <p className="label-adtextfield">Character Offset</p>
                            ) : (
                              (!["Slide Show", "Slide Show Two", "Slide Show Three", "Photo Show Two Amp", "Photo Show Three Amp"].includes(component.attributes.attributes.name) && 
                              !["Photo Show Two Amp", "Photo Show Three Amp"].includes(component.attributes.attributes.title)) ?
                              <p className="label-adtextfield">Paragraph Offset</p> : <p className="label-adtextfield">Slides Offset</p>
                            )}
                            <div className="label-adpoffset-textfield">
                              {isCharCountEligible && enableCharCount ? (
                                <>
                                  <TextField
                                  fullWidth
                                  multiline
                                  rows={1}
                                  placeholder="Enter character offset here..."
                                  defaultValue={
                                    component.get(`adTraits.characterOffset${id}Desktop`) ??
                                    (
                                      !["Slide Show", "Slide Show Two", "Slide Show Three", "Photo Show Two Amp", "Photo Show Three Amp"].includes(component.attributes.attributes.name) &&
                                      !["Photo Show Two Amp", "Photo Show Three Amp"].includes(component.attributes.attributes.title)
                                        ? setTraitValue(`characterOffset${id}Desktop`, 200)
                                        : setTraitValue(`characterOffset${id}Desktop`, 200)
                                    )
                                  }
                                  onChange={(e) => setTraitValue(`characterOffset${id}Desktop`, e.target.value)}
                                  onKeyDown={(e) => {
                                    const isValidKey = /^[0-9]$/.test(e.key);
                                    const isBackspaceOrDelete = ['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight'].includes(e.key);
                                    if (!isValidKey && !isBackspaceOrDelete) {
                                      e.preventDefault();
                                    }
                                  }}
                                  inputProps={{
                                    inputMode: 'numeric',
                                    pattern: '[0-9]*'
                                  }}
                                  style={{ marginBottom: '10px', padding: '0px' }}
                                  />
                                </>
                              ) : (
                                <>
                                  <TextField
                                  fullWidth
                                  multiline
                                  rows={1}
                                  placeholder={(isAdPositionComponent || isStoryListAdComponent) ? "Insert Position(After Only Story)" : "Enter paragraph offset here..."}
                                  defaultValue={
                                    component.get(`adTraits.paragraphOffset${id}Desktop`) ??
                                    (
                                      !["Slide Show", "Slide Show Two", "Slide Show Three", "Photo Show Two Amp", "Photo Show Three Amp"].includes(component.attributes.attributes.name) &&
                                      !["Photo Show Two Amp", "Photo Show Three Amp"].includes(component.attributes.attributes.title)
                                        ? setTraitValue(`paragraphOffset${id}Desktop`, String((index+1) * 2))
                                        : setTraitValue(`paragraphOffset${id}Desktop`, String((index+1)))
                                    )
                                  }
                                  onChange={(e) => {
                                    const value = isAdPositionComponent
                                      ? e.target.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1')
                                      : e.target.value;
                                    setTraitValue(`paragraphOffset${id}Desktop`, value);
                                  }}
                                  onKeyDown={(e) => {
                                    const isValidKey = /^[0-9]$/.test(e.key);
                                    const isValidDecimal = isAdPositionComponent && e.key === '.' && !e.currentTarget.value.includes('.');
                                    const isBackspaceOrDelete = ['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight'].includes(e.key);
                                    if (!isValidKey && !isValidDecimal && !isBackspaceOrDelete) {
                                      e.preventDefault();
                                    }
                                  }}
                                  inputProps={{
                                    maxLength: isAdPositionComponent ? 8 : 2,
                                    inputMode: isAdPositionComponent ? 'decimal' : 'numeric',
                                    pattern: isAdPositionComponent ? '[0-9]*\\.?[0-9]*' : '[0-9]*'
                                  }}
                                  style={{ marginBottom: '10px', padding: '0px' }}
                                  />
                                  {!isAdPositionComponent && !isStoryListAdComponent && ((!["Slide Show", "Slide Show Two", "Slide Show Three", "Photo Show Two Amp", "Photo Show Three Amp"].includes(component.attributes.attributes.name) && 
                                  !["Photo Show Two Amp", "Photo Show Three Amp"].includes(component.attributes.attributes.title)) ?
                                  <p className="label-adpoffset-note">Note: Number of paragraphs before ad rendering in body.</p> : 
                                  <p className="label-adpoffset-note">Note: Number of slides before ad rendering in body. </p>)}
                                </>
                              )}
                            </div>
                          </>
                        )}
                        {component.attributes.attributes.adSlotLable === "Belly" && (
                          <>
                            <p className="label-adtextfield" style={{ marginTop: '10px' }}>Ad Code Height</p>
                            <TextField
                              fullWidth
                              multiline
                              rows={1}
                              placeholder="Enter ad code height here..."
                              defaultValue={getTraitValue(`adCodeHeight${id}Desktop`) || ''}
                              onChange={(e) => setTraitValue(`adCodeHeight${id}Desktop`, e.target.value)}
                              style={{ marginBottom: '10px', padding: '0px' }}
                            />
                          </>
                        )}
                        <p className="label-adtextfield">Header Script</p>
                        <TextField
                          fullWidth
                          multiline
                          rows={4}
                          placeholder="Enter script here..."
                          defaultValue={getTraitValue(`headAdScript${id}Desktop`) || ''}
                          onChange={(e) => setTraitValue(`headAdScript${id}Desktop`, e.target.value)}
                          style={{ marginBottom: '10px', padding: '0px' }}
                        />
                        <p className="label-adtextfield">Body Script</p>
                        <TextField
                          fullWidth
                          multiline
                          rows={4}
                          placeholder="Enter script here..."
                          defaultValue={getTraitValue(`bodyAdScript${id}Desktop`) || ''}
                          onChange={(e) => setTraitValue(`bodyAdScript${id}Desktop`, e.target.value)}
                          style={{ marginBottom: '10px' }}
                        />
                      </div>

                      {/* Delete button moved to bottom */}
                      {MAX_ACCORDIONS > 1 && <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 1 }}>
                        <Button
                          variant="outlined"
                          color="error"
                          size="small"
                          startIcon={<DeleteIcon />}
                          onClick={(e) => {
                            e.stopPropagation();
                            deleteAccordion.call(this, id, component, 'desktop');
                          }}
                          sx={{
                            textTransform: 'none',
                            fontSize: '12px',
                            borderColor: '#d5d5d5',
                            color: '#666',
                            '&:hover': {
                              borderColor: '#f44336',
                              color: '#f44336',
                              backgroundColor: 'rgba(244, 67, 54, 0.04)'
                            }
                          }}
                        >
                          Remove Ad Slot
                        </Button>
                      </Box>}
                    </div>
                  </AccordionDetails>
                </Accordion>
              ))}
              {MAX_ACCORDIONS > 1 && <Button
                variant="contained"
                color="primary"
                 size="small"
                onClick={() => {
                  const currentAccordions = component.get('desktopAccordions') || [1];
                  const newAccordions = [...currentAccordions, Math.max(...currentAccordions) + 1];
                  component.set('desktopAccordions', newAccordions);
                  this.model.view.render();  // Force re-render
                }}
                disabled={(component.get('desktopAccordions') || []).length >= MAX_ACCORDIONS}
                sx={{
                  marginTop: '10px',
                  display: 'block',
                  margin: '10px auto',
                  width: 'fit-content'
                }}
              >
                {component.attributes.attributes.adSlotLable === "Ad" ? "+ New Ad Slot" : "+ New Belly Ad Slot"}
              </Button> }
            </>
          )}

          {/* Mobile View */}
          {deviceType === 'mobile' && !["Left Gutter Ads", "Right Gutter Ads"].includes(component.attributes.attributes.name) && (
            <>
              {(component.get('mobileAccordions') || [1]).map((id, index) => (
                <Accordion
                  key={`mobile-${id}`}
                  sx={{
                    marginBottom: '10px',
                    border: '1px solid #e0e0e0',
                    '&.Mui-expanded': {
                      boxShadow: '0 2px 4px rgba(0,0,0,0.05)'
                    }
                  }}
                >
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls={`panel-mobile-${id}`}
                    id={`panel-mobile-${id}`}
                    style={{ position: 'relative' }}
                  >
                    <Typography>
                      {component.attributes.attributes.adSlotLable === "Ad"
                        ? `Ad code`
                        : `Belly Ad code ${index+1}`}
                    </Typography>

                  </AccordionSummary>
                  <AccordionDetails>

                    <div style={{ width: '100%' }}>
                      {/* Mobile Ad Network */}
                      <FormControl fullWidth style={{ marginBottom: '10px' }}>
                        <Select
                          value={getTraitValue(`adNetwork${id}Mobile`) || 'google'}
                          onChange={(e) => {
                            setTraitValue(`adNetwork${id}Mobile`, e.target.value); // Changed Desktop to Mobile
                            // Force component update
                            component.set(`adTraits.adNetwork${id}Mobile`, e.target.value); // Changed Desktop to Mobile
                            // Trigger a re-render
                            this.model.view.render();
                          }}
                          size="small"
                          style={{
                            display: component.attributes.attributes.dataMappingTrait &&
                              component.attributes.attributes.dataMappingTrait.mappingType !== 'cp' &&
                              component.attributes.attributes.dataMappingTrait.mappingType !== 'ch' &&
                              component.attributes.attributes.dataMappingTrait.selectContainer !== ''
                              ? 'none'
                              : 'block'
                          }}
                        >
                          <MenuItem value="google">Google Ad</MenuItem>
                          <MenuItem value="can">Others</MenuItem>
                        </Select>
                      </FormControl>


                      {/* Mobile Ad Size Radio Group */}
                      {(["Ad Scripts", "Ad Scripts Two", "Ad Scripts Three", "Ad Scripts Amp", "Ad Scripts Two Amp", "Ad Scripts Three Amp"].includes(component.attributes.attributes.name) &&
                      <FormControl fullWidth style={{ marginBottom: '10px' }}>
                        <FormLabel style={{ fontSize: '13px', color: '#8a8a8a' }}>Ad Slot Size</FormLabel>
                        <RadioGroup
                          row
                          defaultValue={getTraitValue(`adSize${id}Mobile`)}
                          onChange={(e) => setTraitValue(`adSize${id}Mobile`, e.target.value)}
                        >
                          <FormControlLabel value="300x250" control={<Radio size="small" />} label="300 X 250" sx={{ '& .MuiFormControlLabel-label': { fontSize: '14px' }, margin: '2px' }} />
                          <FormControlLabel value="300x100" control={<Radio size="small" />} label="300 X 100" sx={{ '& .MuiFormControlLabel-label': { fontSize: '14px' }, margin: '2px' }} />
                          <FormControlLabel value="300x50" control={<Radio size="small" />} label="300 X 50" sx={{ '& .MuiFormControlLabel-label': { fontSize: '14px' }, margin: '2px' }} />
                          <FormControlLabel value="336x280" control={<Radio size="small" />} label="336 X 280" sx={{ '& .MuiFormControlLabel-label': { fontSize: '14px' }, margin: '2px' }} />
                          <FormControlLabel value="others" control={<Radio size="small" />} label="Others" sx={{ '& .MuiFormControlLabel-label': { fontSize: '14px' }, margin: '2px' }} />
                          <FormControlLabel value="stickyOverlayAds" control={<Radio size="small" />} label="Sticky Overlay" sx={{ '& .MuiFormControlLabel-label': { fontSize: '14px' }, margin: '2px' }} />
                        </RadioGroup>
                        {getTraitValue(`adSize${id}Mobile`) === 'others' && (
                          <div style={{ display: 'flex', gap: '10px', marginTop: '10px', marginBottom: '15px' }}>
                            <TextField
                              placeholder="Width"
                              defaultValue={getTraitValue(`adSizeCustomWidth${id}Mobile`) || ''}
                              onBlur={(e) => setTraitValue(`adSizeCustomWidth${id}Mobile`, e.target.value)}
                              size="small"
                              style={{ flex: 1 }}
                            />
                            <TextField
                              placeholder="Height"
                              defaultValue={getTraitValue(`adSizeCustomHeight${id}Mobile`) || ''}
                              onBlur={(e) => setTraitValue(`adSizeCustomHeight${id}Mobile`, e.target.value)}
                              size="small"
                              style={{ flex: 1 }}
                            />
                          </div>
                        )}
                      </FormControl>
                      )}

                      {/* Mobile Scripts */}
                      <div className="adScriptWrapper">
                        {component.attributes.attributes.adSlotLable === "Belly" && (
                          <>
                            {(isAdPositionComponent || isStoryListAdComponent) ? (
                              <p className="label-adtextfield">Insert Position(After Only Story)</p>
                            ) : isCharCountEligible && enableCharCount ? (
                              <p className="label-adtextfield">Character Offset</p>
                            ) : (
                              (!["Slide Show", "Slide Show Two", "Slide Show Three", "Photo Show Two Amp", "Photo Show Three Amp"].includes(component.attributes.attributes.name) && 
                              !["Photo Show Two Amp", "Photo Show Three Amp"].includes(component.attributes.attributes.title)) ?
                              <p className="label-adtextfield">Paragraph Offset</p> : <p className="label-adtextfield">Slides Offset</p>
                            )}
                            <div className="label-adpoffset-textfield">
                              {isCharCountEligible && enableCharCount ? (
                                <>
                                  <TextField
                                  fullWidth
                                  multiline
                                  rows={1}
                                  placeholder="Enter character offset here..."
                                  defaultValue={
                                    component.get(`adTraits.characterOffset${id}Mobile`) ??
                                    (
                                      !["Slide Show", "Slide Show Two", "Slide Show Three", "Photo Show Two Amp", "Photo Show Three Amp"].includes(component.attributes.attributes.name) &&
                                      !["Photo Show Two Amp", "Photo Show Three Amp"].includes(component.attributes.attributes.title)
                                        ? setTraitValue(`characterOffset${id}Mobile`, 200)
                                        : setTraitValue(`characterOffset${id}Mobile`, 200)
                                    )
                                  }
                                  onChange={(e) => setTraitValue(`characterOffset${id}Mobile`, e.target.value)}
                                  onKeyDown={(e) => {
                                    const isValidKey = /^[0-9]$/.test(e.key);
                                    const isBackspaceOrDelete = ['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight'].includes(e.key);
                                    if (!isValidKey && !isBackspaceOrDelete) {
                                      e.preventDefault();
                                    }
                                  }}
                                  inputProps={{
                                    inputMode: 'numeric',
                                    pattern: '[0-9]*'
                                  }}
                                  style={{ marginBottom: '10px', padding: '0px' }}
                                  />
                                </>
                              ) : (
                                <>
                                  <TextField
                                  fullWidth
                                  multiline
                                  rows={1}
                                  placeholder={(isAdPositionComponent || isStoryListAdComponent) ? "Insert Position(After Only Story)" : "Enter paragraph offset here..."}
                                  defaultValue={
                                    component.get(`adTraits.paragraphOffset${id}Mobile`) ??
                                    (
                                      !["Slide Show", "Slide Show Two", "Slide Show Three", "Photo Show Two Amp", "Photo Show Three Amp"].includes(component.attributes.attributes.name) &&
                                      !["Photo Show Two Amp", "Photo Show Three Amp"].includes(component.attributes.attributes.title)
                                        ? setTraitValue(`paragraphOffset${id}Mobile`, String((index+1) * 2))
                                        : setTraitValue(`paragraphOffset${id}Mobile`, String((index+1)))
                                    )
                                  }
                                  onChange={(e) => {
                                    // Vertical List Four: the box keeps what was typed (so "12" can be
                                    // typed through "1"), but only the even value is ever stored.
                                    const value = isAdPositionComponent
                                      ? e.target.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1')
                                      : isStoryListAdComponent
                                        ? toEvenStoryPosition(e.target.value)
                                        : e.target.value;
                                    setTraitValue(`paragraphOffset${id}Mobile`, value);
                                  }}
                                  onBlur={(e) => {
                                    if (!isStoryListAdComponent) return;
                                    // Leaving the box shows the stored even value in place of what was typed.
                                    const typed = e.target.value.trim();
                                    const even = toEvenStoryPosition(e.target.value);
                                    e.target.value = even;
                                    setTraitValue(`paragraphOffset${id}Mobile`, even);
                                    // Number() so "00" -> "0" or a trailing space is not reported as a change.
                                    if (typed !== '' && String(Number(typed)) !== even) {
                                      flashEvenPositionChange(e.target, typed, even);
                                    }
                                  }}
                                  onKeyDown={(e) => {
                                    const isValidKey = /^[0-9]$/.test(e.key);
                                    const isValidDecimal = isAdPositionComponent && e.key === '.' && !e.currentTarget.value.includes('.');
                                    const isBackspaceOrDelete = ['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight'].includes(e.key);
                                    if (!isValidKey && !isValidDecimal && !isBackspaceOrDelete) {
                                      e.preventDefault();
                                    }
                                  }}
                                  inputProps={{
                                    maxLength: isAdPositionComponent ? 8 : 2,
                                    inputMode: isAdPositionComponent ? 'decimal' : 'numeric',
                                    pattern: isAdPositionComponent ? '[0-9]*\\.?[0-9]*' : '[0-9]*'
                                  }}
                                  style={{ marginBottom: '10px', padding: '0px' }}
                                  />
                                  {!isAdPositionComponent && !isStoryListAdComponent && ((!["Slide Show", "Slide Show Two", "Slide Show Three", "Photo Show Two Amp", "Photo Show Three Amp"].includes(component.attributes.attributes.name) && 
                                  !["Photo Show Two Amp", "Photo Show Three Amp"].includes(component.attributes.attributes.title)) ?
                                  <p className="label-adpoffset-note">Note: Number of paragraphs before ad rendering in body.</p> : 
                                  <p className="label-adpoffset-note">Note: Number of slides before ad rendering in body. </p>)}
                                  {isStoryListAdComponent && (
                                    <p className="label-adpoffset-note even-position-note" aria-live="polite">{EVEN_POSITION_NOTE}</p>
                                  )}
                                </>
                              )}
                            </div>
                          </>
                        )}
                        {component.attributes.attributes.adSlotLable === "Belly" && (
                          <>
                            <p className="label-adtextfield" style={{ marginTop: '10px' }}>Ad Code Height</p>
                            <TextField
                              fullWidth
                              multiline
                              rows={1}
                              placeholder="Enter ad code height here..."
                              defaultValue={getTraitValue(`adCodeHeight${id}Mobile`) || ''}
                              onChange={(e) => setTraitValue(`adCodeHeight${id}Mobile`, e.target.value)}
                              style={{ marginBottom: '10px', padding: '0px' }}
                            />
                          </>
                        )}
                        <p className="label-adtextfield">Header Script</p>
                        <TextField
                          fullWidth
                          multiline
                          rows={4}
                          placeholder="Enter script here..."
                          defaultValue={getTraitValue(`headAdScript${id}Mobile`) || ''}
                          onChange={(e) => setTraitValue(`headAdScript${id}Mobile`, e.target.value)}
                          style={{ marginBottom: '10px' }}
                        />
                        <p className="label-adtextfield">Body Script</p>
                        <TextField
                          fullWidth
                          multiline
                          rows={4}
                          placeholder="Enter script here..."
                          defaultValue={getTraitValue(`bodyAdScript${id}Mobile`) || ''}
                          onChange={(e) => setTraitValue(`bodyAdScript${id}Mobile`, e.target.value)}
                          style={{ marginBottom: '10px' }}
                        />
                      </div>

                      {/* Delete button moved to bottom */}
                      {MAX_ACCORDIONS > 1 && <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 1 }}>
                        <Button
                          variant="outlined"
                          color="error"
                          size="small"
                          startIcon={<DeleteIcon />}
                          onClick={(e) => {
                            e.stopPropagation();
                            deleteAccordion.call(this, id, component, 'mobile');
                          }}
                          sx={{
                            textTransform: 'none',
                            fontSize: '12px',
                            borderColor: '#d5d5d5',
                            color: '#666',
                            '&:hover': {
                              borderColor: '#f44336',
                              color: '#f44336',
                              backgroundColor: 'rgba(244, 67, 54, 0.04)'
                            }
                          }}
                        >
                          Remove Ad Slot
                        </Button>
                      </Box> }
                    </div>
                  </AccordionDetails>
                </Accordion>
              ))}
              {MAX_ACCORDIONS > 1 && <Button
                variant="contained"
                color="primary"
                size="small"
                onClick={() => {
                  const currentAccordions = component.get('mobileAccordions') || [1];
                  const newAccordions = [...currentAccordions, Math.max(...currentAccordions) + 1];
                  component.set('mobileAccordions', newAccordions);
                  this.model.view.render();  // Force re-render
                }}
                disabled={(component.get('mobileAccordions') || []).length >= MAX_ACCORDIONS}
                sx={{
                  marginTop: '10px',
                  display: 'block',
                  margin: '10px auto',
                  width: 'fit-content'
                }}
              >
                {component.attributes.attributes.adSlotLable === "Ad" ? "+ New Ad Slot" : "+ New Belly Ad Slot"}
              </Button>}
            </>
          )}
        </div>
        </Box>
      );

      ReactDOM.render(
        AdSlottextObj1,
        this.model.view.el.querySelector("#accordian-testing-1234")
      );

      // Initialize the configurations when the trait is first rendered
      updateAdConfigurations();
    },
  });





};

const PopulateGlobalSettingsData = (data, el) => {
  if (typeof data.json !== "undefined" && JSON.parse(data.json) != null) {
    const jsonObj = JSON.parse(data.json);
    const typo_array = ["h1", "h2", "h3", "h4", "h5", "h6", "p"];

    typo_array.forEach((element) => {
      const fontSize = defaultFontSizes[element];
      const fontWeight = defaultFontWeight[element];
      el.elInput.querySelector(`#typography-${element}-font-family`).value = jsonObj[`typography_${element}`][`font-family`];
      el.elInput.querySelector(`#typography-${element}-font-size`).value = jsonObj[`typography_${element}`][`font-size`][`value`] == "" ? fontSize : jsonObj[`typography_${element}`][`font-size`][`value`];
      el.elInput.querySelector(`#typography-${element}-font-size-end`).value = jsonObj[`typography_${element}`][`font-size`][`unit`];
      el.elInput.querySelector(`#typography-${element}-font-weight`).value = jsonObj[`typography_${element}`][`font-weight`] == "" ? fontWeight : jsonObj[`typography_${element}`][`font-weight`];
      el.elInput.querySelector(`#typography-${element}-character-spacing`).value = jsonObj[`typography_${element}`][`letter-spacing`][`value`] == "" ? 0 : jsonObj[`typography_${element}`][`letter-spacing`][`value`];
      el.elInput.querySelector(`#typography-${element}-character-spacing-end`).value = jsonObj[`typography_${element}`][`letter-spacing`][`unit`];
      el.elInput.querySelector(`#typography-${element}-line-spacing`).value = jsonObj[`typography_${element}`][`line-height`];
      el.elInput.querySelector(`#typography-${element}-text-transform`).value = jsonObj[`typography_${element}`][`text-transform`];
    });

    if (jsonObj.root != null && jsonObj.root != "")
      if (Array.from(el.elInput.querySelectorAll('input[name="ColorSet"]')).length > 0)
        Array.from(el.elInput.querySelectorAll('input[name="ColorSet"]')).filter((input) => input.value == JSON.stringify(jsonObj.root))[0].checked = true;
      else {
        if (Array.from(el.elInput.querySelectorAll('input[name="ColorSet"]')).length > 0)
          Array.from(el.elInput.querySelectorAll('input[name="ColorSet"]'))[0].checked = true;
      }
    // if(cssObj.content_color_set_value!=null && cssObj.content_color_set_value!='')
    //     Array.from(el.elInput.querySelectorAll('input[name="contentColorSet"]')).filter(input => input.value == cssObj.content_color_set_value)[0].checked = true;
    // if(cssObj.background_color_set_value!=null && cssObj.background_color_set_value!='')
    //     Array.from(el.elInput.querySelectorAll('input[name="backgroudColorSet"]')).filter(input => input.value == cssObj.background_color_set_value)[0].checked = true;

    el.elInput.querySelector(`#date-time-format`).value = jsonObj[`date-time-format`];
    el.elInput.querySelector(`#published-or-updated`).value = jsonObj[`published-or-updated`];
    // if(jsonObj.time_format!=null && jsonObj.time_format!='')
    //   Array.from(el.elInput.querySelectorAll('input[name="time-format"]')).filter(input => input.value == jsonObj.time_format)[0].checked = true;

    //global header and body scripts
    if (jsonObj.globalHeaderScript != null && jsonObj.globalHeaderScript != "") {
      el.elInput.querySelector(`#globalHeaderScript`).value = jsonObj.globalHeaderScript;
      appendScriptToHeadOrBody("header_script", jsonObj.globalHeaderScript);
    }

    if (jsonObj.globalBodyScript != null && jsonObj.globalBodyScript != "") {
      el.elInput.querySelector(`#globalBodyScript`).value = jsonObj.globalBodyScript;
      appendScriptToHeadOrBody("body_script", jsonObj.globalBodyScript);
    }

    //el.elInput.querySelector(`#time-zone`).value = jsonObj[`time-zone`];

    // el.elInput.querySelector(`#breadcrumbs-seprator`).value = jsonObj[`breadcrumbs-seprator`];
    // el.elInput.querySelector(`#anchor-text-for-homepage`).value = jsonObj[`anchor-text-for-homepage`];
    // el.elInput.querySelector(`#prefix-for-search-result-page`).value = jsonObj[`prefix-for-search-result-page`];
    // el.elInput.querySelector(`#anchor-text-for-404`).value = jsonObj[`anchor-text-for-404`];
  }
};

const getParentComponentsInView1 = (params) => {
  const filteredChildComponents = [];
  if (window.gpEditor) {
    //add all from the parents
    //filteredChildComponents.push(window.gpEditor.getComponents().filter((op)=> PARENT_COMPONENTS_DATA_MAPPING.includes(op.attributes.type)))
    //add all from the childs
    window.gpEditor.getComponents().forEach((parentComponent) => {
      if (PARENT_COMPONENTS_DATA_MAPPING.includes(parentComponent.attributes.type)) {
        filteredChildComponents.push(parentComponent);
      }
      parentComponent.forEachChild((childComponent) => {
        if (PARENT_COMPONENTS_DATA_MAPPING.includes(childComponent.attributes.type)) {
          filteredChildComponents.push(childComponent);
        }
      });
    });
  }
  return filteredChildComponents;
};

const getParentComponentsInView2 = (params) => {
  const filteredChildComponents = [];
  if (window.gpEditor) {
    //add all from the parents
    //filteredChildComponents.push(window.gpEditor.getComponents().filter((op)=> PARENT_COMPONENTS_DATA_MAPPING.includes(op.attributes.type)))
    //add all from the childs
    window.gpEditor.getComponents().forEach((parentComponent) => {
      if (PARENT_COMPONENTS_DATA_MAPPING.includes(parentComponent.attributes.type)) {
        filteredChildComponents.push(parentComponent);
      }
      parentComponent.forEachChild((childComponent) => {
        if (PARENT_COMPONENTS_DATA_MAPPING.includes(childComponent.attributes.type)) {
          filteredChildComponents.push(childComponent);
        }
      });
    });
  }
  return filteredChildComponents;
};

const getParentComponentsInView3 = (params) => {
  const filteredChildComponents = [];
  if (window.gpEditor) {
    //add all from the parents
    //filteredChildComponents.push(window.gpEditor.getComponents().filter((op)=> PARENT_COMPONENTS_DATA_MAPPING.includes(op.attributes.type)))
    //add all from the childs
    window.gpEditor.getComponents().forEach((parentComponent) => {
      if (PARENT_COMPONENTS_DATA_MAPPING.includes(parentComponent.attributes.type)) {
        filteredChildComponents.push(parentComponent);
      }
      parentComponent.forEachChild((childComponent) => {
        if (PARENT_COMPONENTS_DATA_MAPPING.includes(childComponent.attributes.type)) {
          filteredChildComponents.push(childComponent);
        }
      });
    });
  }
  return filteredChildComponents;
};

const stopMethodOnClick = (e) => {
  // Call the stop method
  if (e.target.title == "More apps") {
    return false;
  }
  window.gpEditor.Panels.getButton("views", "nine-dots").set("active", false);
  document.body.removeEventListener('click', stopMethodOnClick);
}

export const addCustomPanelTools = (editor, toggleSaveModal, setPublishToProd) => {
  const panelManager = editor.Panels;
  editor.getConfig().showDevices = 0;
  editor.Panels.addPanel({
    id: 'devices', buttons: [
      {
        name: "dsf", id: "set-device-desktop", command: {
          run: function (e) {
            setDeviceAndView("Desktop")
          }, stop() { }
        }, togglable: true, className: "fa fa-desktop", active: true
      },
      {
        name: "dssdf", id: "set-device-mobile", command: {
          run: function (e) {
            setDeviceAndView("Mobile portrait");
          }, stop() { }
        }, togglable: true, className: "fa fa-mobile",
      }
    ]
  });

  function setDeviceAndView(device) {
    editor.setDevice(device);
    //Refresh the view
    const content = JSON.stringify(editor.getComponents());
    editor.setComponents(JSON.parse(content));
  }

  editor.Panels.addButton('options', {
    id: 'custom-panel',
    className: 'fa fa-undo',
    command: 'undo',
    togglable: true,
    attributes: {
      title: 'Undo', // Tooltip text
    },
  });

  editor.Panels.addButton('options', {
    id: 'custom-panel2',
    className: 'fa fa-repeat',
    command: 'redo',
    togglable: true,
    attributes: {
      title: 'Redo', // Tooltip text
    },
  });

  editor.Commands.add("undo", {
    run: (editor) => {
      editor.runCommand("core:undo")
    },
    stop() { }
  });

  editor.Commands.add("redo", {
    run: (editor) => editor.runCommand("core:redo"),
    stop() { }
  });
  editor.Panels.addButton("views", {
    id: "save-menu-management",
    className: 'menumgmt',
    togglable: true,
    command: "save-menu-command",
    attributes: {
      title: "Menu Management",
    },
  });

  editor.Panels.addButton("views", {
    id: "save-global-settings",
    className: "fa fa-sliders",
    togglable: true,
    command: "save-global-command",
    attributes: {
      title: "Global Settings",
    },
  });


  editor.Panels.addButton("views", {
    id: "nine-dots",
    className: "fa fa-th",
    command: "nine-dots",
    togglable: true,
    attributes: {
      title: "More apps",
    },
  });

  let dotsHtml = '';
  fetch("/static/moreapps/links.json").then((raww) => {
    raww.json().then((res) => {

      if (res && res.appLinks) {
        let appLinks = res.appLinks;
        for (let dot of appLinks) {
          if (dot.active) {
            dotsHtml += `<li title="${dot.title}">
              <a href="${dot.isDisabled ? 'javascript:void(0)' : dot.link}" target="#" title="${dot.tooltip}">
                <i>
                  <img src="${dot.icon}">
                </i>
                <p>${dot.title}</p>
              </a>
            </li>`
          }
        }

        var overlay;
        editor.Commands.add("nine-dots", {
          run: () => {
            if (!overlay) {
              overlay = document.createElement('div');
              overlay.innerHTML = `
             
              <div class="more-appsoverlay">
              <ul>
                ${dotsHtml}
              </ul>
              </div>
              `
              const panels = editor.Panels.getPanel('views')
              panels.set('appendContent', overlay).trigger('change:appendContent');
            }
            overlay.style.display = "block";
            document.body.addEventListener('click', stopMethodOnClick);
          },
          stop() {
            if (overlay) {
              overlay.style.display = 'none';
            }
          }
        });

      }

    });
  });


  editor.Panels.addButton("views", {
    id: "logout",
    className: "fa fa-sign-out",
    command: "logout",
    attributes: {
      title: "Logout", // Tooltip text
    },
  });

  editor.Commands.add("logout", {
    run: function (editor) {
      logoutUserSession();
    }.bind(this),
    stop() { }
  });

  editor.Panels.addButton("options", [
    {
      id: "savebtn",
      className: "fa fa-save",
      command: "save-db",
      togglable: false,
      attributes: {
        title: "Save",
      },
    },
  ]);

  // editor.Panels.addButton("options", [
  //   {
  //     id: "save-layout",
  //     className: "fa fa-columns",
  //     command: "save-layout",
  //     togglable: true,
  //     attributes: {
  //       title: "Save Layout",
  //     },
  //   },
  // ]);

  editor.Commands.add("save-db", {
    run: async function (editor, sender) {
      let comps = JSON.stringify(editor.getComponents());
      let css = JSON.stringify(getCss(editor));
      
      // Check for multiple Gutter Ads
      let gutterAdsValidation = checkForMultipleGutterAds(JSON.parse(comps));
      if (!gutterAdsValidation.isValid) {
        showErrorToast(gutterAdsValidation.message);
        return;
      }

      let isFullScreenComponentPresent = checkForFullScreenComponents(JSON.parse(comps));
      if (isFullScreenComponentPresent) {

        showWarningToast("Full Width Components may interfere with Gutter Ads");
        // const userConfirmed = await showWarningToastFrConfirmation("One or more full width components exist(s) on this page. This may break the user experience with gutter ads. Are you sure you want to continue? ", true);
        // if (!userConfirmed) {
        //   return;
        // }
      } 

      persistData(comps, css);
      toggleSaveModal(true);
      setPublishToProd(false);
      editor.Panels.getButton("options", "savebtn").set("attributes", { title: "Already Saved" });
    }.bind(this),
    stop() {
      editor.Panels.getButton("options", "savebtn").set("attributes", { title: "Save" });
    }
  });

  editor.Panels.addButton("options", [
    {
      id: "publishBtn",
      className: "fa fa-upload",
      command: "publish-db",
      togglable: false,
      attributes: {
        title: "Publish",
      },
    },
  ]);

  editor.Commands.add("publish-db", {
    run: function (editor, sender) {
      let comps = JSON.stringify(editor.getComponents());
      let css = JSON.stringify(getCss(editor));

      // Check for multiple Gutter Ads
      let gutterAdsValidation = checkForMultipleGutterAds(JSON.parse(comps));
      if (!gutterAdsValidation.isValid) {
        showErrorToast(gutterAdsValidation.message);
        return;
      }

      let defaultIds = localStorage.getItem("defaultIds");
      let isDummyDataPresent = false;
      if (defaultIds && defaultIds.length) {
        isDummyDataPresent = checkForDummyIDs(JSON.parse(comps), JSON.parse(defaultIds));
        if (isDummyDataPresent) {
          showErrorToast("Data mapping for one or more components is missing");
        }
      }

      // let isFullScreenComponentPresent = checkForFullScreenComponents(JSON.parse(comps));
      // if (isFullScreenComponentPresent) {
      //   console.log("Full screen components are not allowed in published pages with gutter ads");
      // } else {
      //   console.log("No Full screen components found");
      // }

      if (!isDummyDataPresent) {
        persistData(comps, css);
        toggleSaveModal(true);
        setPublishToProd(true);
        editor.Panels.getButton("options", "publishBtn").set("attributes", { title: "Already Published" });
      }
    }.bind(this),
    stop() {
      editor.Panels.getButton("options", "publishBtn").set("attributes", { title: "Publish" });
    }
  });

  // editor.Commands.add("save-layout", {
  //   run: function (editor, sender) {
  //     let comps = JSON.stringify(editor.getComponents());
  //     let css = JSON.stringify(getCss(editor));
  //     persistData(comps, css);
  //     savePageLayout();
  //   },
  //   stop() {}
  // });

  // Add a custom button with an icon

  editor.on("run:clear-canvas", () => {
    persistData("", "");
  });


  let element = null;
  editor.Commands.add("save-global-command", {
    run: function () {
      if (!element) {
        let globalJson = JSON.parse(getSessionObject('globalJson'));
        let globalCss = JSON.parse(getSessionObject('globalCss'));
        let siteResourceData = getDefaultMsids();
        // let themeData=getThemePagesByWebsite();
        //console.log("site: ",siteResourceData);
        const editMenuDiv = document.createElement('div');
        ReactDOM.render(<GlobalSettingComponent siteResource={siteResourceData} themeJson={globalJson} themeCss={globalCss} />, editMenuDiv);
        const panels = editor.Panels.getPanel('views-container')
        panels && panels.set('appendContent', editMenuDiv).trigger('change:appendContent');
        element = editMenuDiv
      }
      element.style.display = 'block';
    },
    stop: () => {
      if (element) {
        element.style.display = 'none';
        element = null;
      }
    }
  });

  editor.Commands.add("save-menu-command", {
    run: function () {
      if (!element) {
        let globalJson = JSON.parse(getSessionObject('globalJson'));
        let globalCss = JSON.parse(getSessionObject('globalCss'));
        let siteResourceData = getDefaultMsids();
        // let themeData=getThemePagesByWebsite();
        //console.log("site: ", siteResourceData);
        const editMenuDiv = document.createElement('div');
        ReactDOM.render(<MenuManagementComponent siteResource={siteResourceData} themeJson={globalJson} themeCss={globalCss} />, editMenuDiv);
        const panels = editor.Panels.getPanel('views-container')
        panels && panels.set('appendContent', editMenuDiv).trigger('change:appendContent');
        element = editMenuDiv
      }
      element.style.display = 'block';
    },
    stop: () => {
      if (element) {
        element.style.display = 'none';
        element = null;
      }
    }
  });

  editor.on("storage:autosave", () => {
    //console.log("save timestamp");
  });
};
